import { AngularFireAuth } from "@angular/fire/compat/auth";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { finalize, shareReplay, tap } from "rxjs/operators";
import { UploadBannerService } from "./upload-banner.service";
import { EncryptionService } from './encryption.service';
// utils function
import { requestToken } from "../../utils/auth.utils";
import { ApiCacheService } from "./api-cache.service";
import { log } from "console";

/**
 * Adds the host's IANA time zone ("Australia/Brisbane"). The Lambdas that mint
 * WhatsApp links write "valid until …" into the message text, and they run in
 * UTC: without this the guest read a UTC time with no zone on it.
 */
function setHostTimeZone(params: HttpParams): HttpParams {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return zone ? params.set("timeZone", zone) : params;
  } catch {
    return params;
  }
}

@Injectable({
  providedIn: "root",
})
export class EventService {

  eventData: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  userCurrentTime: any;
  userExpirationTime: any;
  refToken: any;
  encryptedData: any;
  decryptedData: any;
  constructor(private http: HttpClient, private apiCache: ApiCacheService,
    private afAuth: AngularFireAuth, private encryptionService: EncryptionService,
    private uploadBanner: UploadBannerService) { }

  storePassedEvent(PassedEvent: any) {
    this.eventData.next(PassedEvent);
  }

  retrievePassedEvent() {
    return this.eventData;
  }

  async linkGuestToUser(uid: string, eventIdE: any) {
    const event_id = localStorage.getItem('eventId');
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)

      const params = new HttpParams()
        .set("uid", uid)
        .set("event_id", eventIdE?.toString()!);

      return this.http.post(
        "https://p6a96zc7d3.execute-api.us-west-1.amazonaws.com/dev/pwa-migrate-guest-files",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)

      const params = new HttpParams()
        .set("uid", uid)
        .set("event_id", eventIdE?.toString()!);

      return this.http.post(
        "https://p6a96zc7d3.execute-api.us-west-1.amazonaws.com/dev/pwa-migrate-guest-files",
        params.toString(),
        { headers }
      );
    }
  }

  async updateScheduledEvent(eventID: any, name: any, location: any, message: any, rsvp: any, coverImage: any, startTime: any, endTime: any, categoryName: any, defaultImageId: any, hostedBy: any, useNow: any) {
    let cleanedMessage = (decodeURIComponent(message)).replace(/^"(.*)"$/, '$1')
    // console.log(cleanedMessage); //__CONSOLE_LOG__
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)

      const params = new HttpParams()
        .set("event_id", eventID)
        .set("name", name)
        .set("message", cleanedMessage)
        .set("category", categoryName)
        .set("rsvp", rsvp)
        .set("default_image_id", defaultImageId)
        .set("coverImage", coverImage)
        .set("eventLocation", location)
        .set("start_time", startTime)
        .set("end_time", endTime)
        .set("hosted_by", hostedBy)
        .set("isLive", useNow.toString());

      return this.http.post(
        "https://lwwusxlzi4.execute-api.us-west-1.amazonaws.com/pwa_update_scheduled_event",
        params.toString(),
        { headers }
      );

    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)

      const params = new HttpParams()
        .set("event_id", eventID)
        .set("name", name)
        .set("message", cleanedMessage)
        .set("category", categoryName)
        .set("rsvp", rsvp)
        .set("default_image_id", defaultImageId)
        .set("coverImage", coverImage)
        .set("eventLocation", location)
        .set("start_time", startTime)
        .set("end_time", endTime)
        .set("hosted_by", hostedBy)
        .set("isLive", useNow.toString());
      return this.http.post(
        "https://lwwusxlzi4.execute-api.us-west-1.amazonaws.com/pwa_update_scheduled_event",
        params.toString(),
        { headers }
      );

    }
  }





  async updatePastEvent(eventID: any, name: any, categoryName: any) {

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)

      const params = new HttpParams()
        .set("event_id", eventID)
        .set("name", name)
        .set("category", categoryName);

      return this.http.post(
        "https://o8z8y3xs2l.execute-api.us-west-1.amazonaws.com/pwa_update-past_event",
        params.toString(),
        { headers }
      );

    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)

      const params = new HttpParams()
        .set("event_id", eventID)
        .set("name", name)
        .set("category", categoryName);


      return this.http.post(
        "https://o8z8y3xs2l.execute-api.us-west-1.amazonaws.com/pwa_update-past_event",
        params.toString(),
        { headers }
      );

    }
  }


  async saveDownloadLogs(eventID: any, file_id: any) {

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)

      const params = new HttpParams()
        .set("event_id", eventID.toString())
        .set("file_id", file_id);

      return this.http.post(
        "https://po3mb2mjaf.execute-api.us-west-1.amazonaws.com/pwa_save_download_logs",
        params.toString(),
        { headers }
      );

    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)

      const params = new HttpParams()
        .set("event_id", eventID.toString())
        .set("file_id", file_id);


      return this.http.post(
        "https://po3mb2mjaf.execute-api.us-west-1.amazonaws.com/pwa_save_download_logs",
        params.toString(),
        { headers }
      );

    }
  }

  async saveUserPolicyLog(policyId: any, action: string, source: string, ipAddress: string) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)

      const params = new HttpParams()
        .set("policy_id", policyId ? policyId.toString() : '')
        .set("status", action)
        .set("source", source)
        .set("ip", ipAddress);

      return this.http.post(
        "https://mh4s3nh2o5.execute-api.us-west-1.amazonaws.com/dev/add-user-policy-log",
        params.toString(),
        { headers }
      );

    } else {
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)

      const params = new HttpParams()
        .set("policy_id", policyId ? policyId.toString() : '')
        .set("status", action)
        .set("source", source)
        .set("ip", ipAddress);

      return this.http.post(
        "https://mh4s3nh2o5.execute-api.us-west-1.amazonaws.com/dev/add-user-policy-log",
        params.toString(),
        { headers }
      );
    }
  }

  async saveSubFolder(eventID: any, subFolderName: any, editFolderId: any) {

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)

      const params = new HttpParams()
        .set("event_id", eventID.toString())
        .set("subfolder_name", subFolderName.toString())
        .set("edit_folder_id", editFolderId.toString());

      return this.http.post(
        "https://q8baox4kyf.execute-api.us-west-1.amazonaws.com/pwa_save_event_subFolder",
        params.toString(),
        { headers }
      );

    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)

      const params = new HttpParams()
        .set("event_id", eventID.toString())
        .set("subfolder_name", subFolderName.toString())
        .set("edit_folder_id", editFolderId.toString());

      return this.http.post(
        "https://q8baox4kyf.execute-api.us-west-1.amazonaws.com/pwa_save_event_subFolder",
        params.toString(),
        { headers }
      );

    }
  }


  async removeSubFolder(eventID: any, editFolderId: any) {

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)

      const params = new HttpParams()
        .set("event_id", eventID.toString())
        .set("edit_folder_id", editFolderId.toString());

      return this.http.post(
        "https://2ealatbnwh.execute-api.us-west-1.amazonaws.com/pwa_remove_event_subFolder",
        params.toString(),
        { headers }
      );

    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)

      const params = new HttpParams()
        .set("event_id", eventID.toString())
        .set("edit_folder_id", editFolderId.toString());

      return this.http.post(
        "https://2ealatbnwh.execute-api.us-west-1.amazonaws.com/pwa_remove_event_subFolder",
        params.toString(),
        { headers }
      );

    }
  }


  async changeSubFolder(eventID: any, new_folder_id: any, file_ids: any) {

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)

      const params = new HttpParams()
        .set("event_id", eventID.toString())
        .set("file_ids", file_ids)
        .set("new_folder_id", new_folder_id.toString());

      return this.http.post(
        "https://rvh323xc3f.execute-api.us-west-1.amazonaws.com/pwa_change_event_subFolder",
        params.toString(),
        { headers }
      );

    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)

      const params = new HttpParams()
        .set("event_id", eventID.toString())
        .set("file_ids", file_ids)
        .set("new_folder_id", new_folder_id.toString());


      return this.http.post(
        "https://rvh323xc3f.execute-api.us-west-1.amazonaws.com/pwa_change_event_subFolder",
        params.toString(),
        { headers }
      );

    }
  }


  async linkMobile(mobile: any) {

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)

      const params = new HttpParams()
        .set("mfa", 'false')
        .set("mobile", mobile.toString());
      // .set("category", categoryName);

      return this.http.post(
        "https://eee08gxjo2.execute-api.us-west-1.amazonaws.com/pwa_link_mobile_number",
        params.toString(),
        { headers }
      );

    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)

      const params = new HttpParams()
        .set("mfa", 'false')
        .set("mobile", mobile.toString());


      return this.http.post(
        "https://eee08gxjo2.execute-api.us-west-1.amazonaws.com/pwa_link_mobile_number",
        params.toString(),
        { headers }
      );

    }
  }

  async qrScanCount(metadata: any) {

    // this.encryptedData = localStorage.getItem('user');
    // this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    // const user = JSON.parse(this.decryptedData || "{}");
    // const token: any = user?.stsTokenManager?.accessToken;
    // // Add for AccessToken get
    // const expirationTime = user?.stsTokenManager?.expirationTime;
    // const currentTime = new Date().getTime() / 1000;
    // this.userCurrentTime = new Date(currentTime * 1000);
    // this.userExpirationTime = new Date(expirationTime);
    // // set headers
    // if (this.userCurrentTime < this.userExpirationTime) {
    const headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
    // .set("Authorization", token)

    const params = new HttpParams()
      .set("metadata", metadata.toString());
    // .set("category", categoryName);

    return this.http.post(
      "https://7ylmyrrxn0.execute-api.us-west-1.amazonaws.com/pwa_qr_scan_count",
      params.toString(),
      { headers }
    );

    // } else {
    //   // call utils function for token request
    //   const Reftoken = await requestToken(this.afAuth);
    //   if (Reftoken) {
    //     //   console.log(Reftoken);  
    //     this.refToken = Reftoken;
    //   }
    //   const headers = new HttpHeaders()
    //     .set("Content-Type", "application/x-www-form-urlencoded")
    //     .set("Authorization", this.refToken)

    //   const params = new HttpParams()
    //   .set("metadata", metadata.toString());


    //   return this.http.post(
    //     "https://7ylmyrrxn0.execute-api.us-west-1.amazonaws.com/pwa_qr_scan_count",
    //     params.toString(),
    //     { headers }
    //   );

    // }
  }

  async getHostTransitionInfo(hex: string) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || '{}');
    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    const buildRequest = (authToken: string) => {
      const headers = new HttpHeaders()
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .set('Authorization', authToken);
      const params = new HttpParams().set('hex', hex);
      return this.http.post(
        'https://t6k6zvp9e6.execute-api.us-west-1.amazonaws.com/default/host-transition-request-information',
        params.toString(),
        { headers }
      );
    };

    if (this.userCurrentTime < this.userExpirationTime) {
      return buildRequest(token);
    } else {
      const refToken = await requestToken(this.afAuth);
      if (refToken) this.refToken = refToken;
      return buildRequest(this.refToken);
    }
  }

  async getNotifications() {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || '{}');
    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    const buildRequest = (authToken: string) => {
      const headers = new HttpHeaders()
        .set('Authorization', authToken);
      const params = new HttpParams().set('user_id', user?.uid || '');
      return this.http.get(
        'https://2uir4x3w2l.execute-api.us-west-1.amazonaws.com/default/pwa-get-notifications',
        { headers, params }
      );
    };

    if (this.userCurrentTime < this.userExpirationTime) {
      return buildRequest(token);
    }
    const refToken = await requestToken(this.afAuth);
    if (refToken) {
      this.refToken = refToken;
      return buildRequest(this.refToken);
    }
    // Firebase auth state hasn't synced yet (e.g. right after sign-up) — skip
    // the call instead of sending a guaranteed-401 request with an undefined
    // Authorization header, which the global error interceptor would treat
    // as a real logout.
    return new Observable((observer) => observer.error(new Error('No auth token available')));
  }

  async getMyAccountDetails() {
    const url = 'https://xth639sxif.execute-api.us-west-1.amazonaws.com/pwa_fetch_my_account_details';

    return new Observable((observer) => {
      this.encryptedData = localStorage.getItem('user');
      this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
      const user = JSON.parse(this.decryptedData || '{}');

      const token: any = user?.stsTokenManager?.accessToken;
      const expirationTime = user?.stsTokenManager?.expirationTime;
      const currentTime = new Date().getTime() / 1000;

      this.userCurrentTime = new Date(currentTime * 1000);
      this.userExpirationTime = new Date(expirationTime);

      // ✅ Pick UID for user-specific cache key
      const userId = user?.uid || 'guest';

      const proceed = (finalToken: string) => {
        const headers = new HttpHeaders()
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('Authorization', finalToken);

        // ✅ Include userId in cache key
        const cacheKey = `${url}?uid=${userId}`;

        this.apiCache.getData<any>(cacheKey, { headers }).subscribe({
          next: (data) => observer.next(data),
          error: (err) => observer.error(err),
          complete: () => observer.complete()
        });
      };

      if (this.userCurrentTime < this.userExpirationTime) {
        proceed(token);
      } else {
        requestToken(this.afAuth).then((refToken) => {
          if (refToken) {
            this.refToken = refToken;
            proceed(this.refToken);
          } else {
            // Firebase auth state hasn't synced yet (e.g. right after sign-up)
            // — skip the call instead of sending a guaranteed-401 request with
            // an undefined Authorization header.
            observer.error(new Error('No auth token available'));
          }
        });
      }
    });
  }

  async getBrandingProgress(event_id: any) {
    const headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("event_id", event_id);
    return this.http.get(
      "https://b8z4avv0hi.execute-api.us-west-1.amazonaws.com/default/pwa-get-branding-progress",
      { headers }
    );
  }

  async getUserPlan(forceRefresh = false) {
    const url = 'https://4jccgvdx8j.execute-api.us-west-1.amazonaws.com/default/pwa-get-user-plan';

    return new Observable((observer) => {
      this.encryptedData = localStorage.getItem('user');
      this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
      const user = JSON.parse(this.decryptedData || '{}');

      const token: any = user?.stsTokenManager?.accessToken;
      const expirationTime = user?.stsTokenManager?.expirationTime;
      const currentTime = new Date().getTime() / 1000;

      this.userCurrentTime = new Date(currentTime * 1000);
      this.userExpirationTime = new Date(expirationTime);

      const userId = user?.uid || 'guest';

      const proceed = (finalToken: string) => {
        const headers = new HttpHeaders()
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('Authorization', finalToken);

        const cacheKey = `${url}?uid=${userId}`;

        if (forceRefresh) {
          // Use getFreshData to bypass both in-memory and browser cache entirely,
          // avoiding the stale-while-revalidate emission from loadCachedData.
          this.apiCache.getFreshData<any>(cacheKey, { headers }).subscribe({
            next: (data) => observer.next(data),
            error: (err) => observer.error(err),
            complete: () => observer.complete()
          });
        } else {
          this.apiCache.getData<any>(cacheKey, { headers }).subscribe({
            next: (data) => observer.next(data),
            error: (err) => observer.error(err),
            complete: () => observer.complete()
          });
        }
      };

      if (this.userCurrentTime < this.userExpirationTime) {
        proceed(token);
      } else {
        requestToken(this.afAuth).then((refToken) => {
          if (refToken) this.refToken = refToken;
          proceed(this.refToken);
        });
      }
    });
  }

  async getMyAccountDetails1() {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");

    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    if (this.userCurrentTime < this.userExpirationTime) {
      const options = {
        headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded")
          .set("Authorization", token)
      };
      return this.http.get(
        "https://xth639sxif.execute-api.us-west-1.amazonaws.com/pwa_fetch_my_account_details",
        options
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const options = {
        headers: new HttpHeaders()
          .set("Content-Type", "application/x-www-form-urlencoded")
          .set("Authorization", this.refToken)
      };
      return this.http.get(
        "https://xth639sxif.execute-api.us-west-1.amazonaws.com/pwa_fetch_my_account_details",
        options
      );
    }

  }


  async getScanCount(event_hex: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");

    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    if (this.userCurrentTime < this.userExpirationTime) {
      const options = {
        headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded")
          .set("Authorization", token)
          .set("event_hex", event_hex)

      };
      return this.http.get(
        "https://vxwmsm9d10.execute-api.us-west-1.amazonaws.com/pwa_get_web_qr_scan_count",
        options
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const options = {
        headers: new HttpHeaders()
          .set("Content-Type", "application/x-www-form-urlencoded")
          .set("Authorization", this.refToken)
          .set("event_hex", event_hex)
      };
      return this.http.get(
        "https://vxwmsm9d10.execute-api.us-west-1.amazonaws.com/pwa_get_web_qr_scan_count",
        options
      );
    }

  }

  async getSelfieData(event_hex: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");

    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    if (this.userCurrentTime < this.userExpirationTime) {
      const options = {
        headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded")
          .set("Authorization", token)
          .set("hex", event_hex)

      };
      return this.http.get(
        "https://phs6e441vf.execute-api.us-west-1.amazonaws.com/pwa_fetch_selfie_user_data",
        options
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const options = {
        headers: new HttpHeaders()
          .set("Content-Type", "application/x-www-form-urlencoded")
          .set("Authorization", this.refToken)
          .set("hex", event_hex)
      };
      return this.http.get(
        "https://phs6e441vf.execute-api.us-west-1.amazonaws.com/pwa_fetch_selfie_user_data",
        options
      );
    }

  }


  async getTextImages() {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");

    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    if (this.userCurrentTime < this.userExpirationTime) {
      const options = {
        headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded")
          .set("Authorization", token)
          .set("hex", localStorage.getItem("eventId") || "{}")

      };
      return this.http.get(
        "https://n4rrci94q9.execute-api.us-west-1.amazonaws.com/pwa_get_textImage",
        options
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const options = {
        headers: new HttpHeaders()
          .set("Content-Type", "application/x-www-form-urlencoded")
          .set("Authorization", this.refToken)
          .set("hex", localStorage.getItem("eventId") || "{}")
      };
      return this.http.get(
        "https://n4rrci94q9.execute-api.us-west-1.amazonaws.com/pwa_get_textImage",
        options
      );
    }

  }


  /** getEventQR requests still in flight, by event, so callers asking at the same time share one. */
  private eventQrInFlight = new Map<string, Observable<any>>();

  /**
   * Callers asking for the same event while a request is still out share it:
   * event-detail and the invite screen both ask the moment Share is tapped,
   * which fired pwa_get_event_qr twice on every open (QA 0.0.607). Nothing is
   * kept once it answers — the next call still fetches fresh, as below.
   */
  getEventQR(eventId: any): Observable<any> {
    const key = String(eventId);
    const inFlight = this.eventQrInFlight.get(key);
    if (inFlight) return inFlight;
    const shared = this.fetchEventQR(eventId).pipe(
      finalize(() => this.eventQrInFlight.delete(key)),
      shareReplay({ bufferSize: 1, refCount: false }),
    );
    this.eventQrInFlight.set(key, shared);
    return shared;
  }

  private fetchEventQR(eventId: any): Observable<any> {
    const url = 'https://bb0s5kpma5.execute-api.us-west-1.amazonaws.com/pwa_get_event_qr';
    const cacheKey = `${url}?eventId=${eventId}`;

    return new Observable((observer) => {
      this.encryptedData = localStorage.getItem('user');
      this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
      const user = JSON.parse(this.decryptedData || '{}');

      const token: any = user?.stsTokenManager?.accessToken;
      const expirationTime = user?.stsTokenManager?.expirationTime;
      const currentTime = new Date().getTime() / 1000;

      this.userCurrentTime = new Date(currentTime * 1000);
      this.userExpirationTime = new Date(expirationTime);

      const proceed = (finalToken: string) => {
        const headers = new HttpHeaders()
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('Authorization', finalToken)
          .set('event_id', eventId.toString());

        // QR/hash data must never come from the null-seeded subject or a stale
        // cached body — a partial/empty replay poisons the invite link
        // (hash = "undefined") and breaks the QR image. Always fetch fresh.
        this.apiCache.getFreshData<any>(cacheKey, { headers }).subscribe({
          next: (data) => observer.next(data),
          error: (err) => observer.error(err),
          complete: () => observer.complete()
        });
      };

      if (this.userCurrentTime < this.userExpirationTime) {
        proceed(token);
      } else {
        requestToken(this.afAuth).then((refToken) => {
          if (refToken) this.refToken = refToken;
          proceed(this.refToken);
        });
      }
    });
  }


  // getEventQR(eventId: any): Observable<any> {
  //   // console.log(eventId); //__CONSOLE_LOG__

  //   this.encryptedData = localStorage.getItem('user');
  //   this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
  //   const user = JSON.parse(this.decryptedData || "{}");
  //   const token: any = user?.stsTokenManager?.accessToken;
  //   // Add for AccessToken get
  //   const expirationTime = user?.stsTokenManager?.expirationTime;
  //   const currentTime = new Date().getTime() / 1000;
  //   this.userCurrentTime = new Date(currentTime * 1000);
  //   this.userExpirationTime = new Date(expirationTime);
  //   // set headers
  //   if (this.userCurrentTime < this.userExpirationTime) {
  //     const headers = new HttpHeaders()
  //       .set("Content-Type", "application/x-www-form-urlencoded")
  //       .set("Authorization", token)
  //       .set("event_id", eventId.toString())
  //     return this.http.get(
  //       "https://bb0s5kpma5.execute-api.us-west-1.amazonaws.com/pwa_get_event_qr",
  //       { headers }
  //     );

  //   } else {
  //     // call utils function for token request
  //     const Reftoken = requestToken(this.afAuth);
  //     if (Reftoken) {
  //       //   console.log(Reftoken);  
  //       this.refToken = Reftoken;
  //     }
  //     const headers = new HttpHeaders()
  //       .set("Content-Type", "application/x-www-form-urlencoded")
  //       .set("Authorization", this.refToken)
  //       .set("event_id", eventId.toString())

  //     return this.http.get(
  //       "https://bb0s5kpma5.execute-api.us-west-1.amazonaws.com/pwa_get_event_qr",
  //       { headers }
  //     );

  //   }
  // }

  async removeUser(eventId: any, user_id: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("collaborator_id", user_id.toString());

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://11cc17pxp3.execute-api.us-west-1.amazonaws.com/pwa-remove-user",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("collaborator_id", user_id.toString());
      return this.http.post(
        "https://11cc17pxp3.execute-api.us-west-1.amazonaws.com/pwa-remove-user",
        params.toString(),
        { headers }
      );
    }
  }

  async requestHostTransition(
    eventId: any,
    userId: any,
    requestedHostId: any,
    eventName: string,
    userName: string,
    source: string = 'pwa'
  ) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || '{}');
    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    const buildRequest = (authToken: string) => {
      const headers = new HttpHeaders()
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .set('Authorization', authToken);
      const params = new HttpParams()
        .set('event_id', eventId.toString())
        .set('user_id', userId.toString())
        .set('requested_host_id', requestedHostId.toString())
        .set('event_name', eventName)
        .set('user_name', userName)
        .set('source', source);
      return this.http.post(
        'https://z8qx9k6v7d.execute-api.us-west-1.amazonaws.com/default/host-transition-request',
        params.toString(),
        { headers }
      );
    };

    if (this.userCurrentTime < this.userExpirationTime) {
      return buildRequest(token);
    } else {
      const refToken = await requestToken(this.afAuth);
      if (refToken) this.refToken = refToken;
      return buildRequest(this.refToken);
    }
  }

  async respondToHostTransition(
    eventId: any,
    userId: any,
    hostId: any,
    eventName: string,
    userName: string,
    transitionRequestId: any,
    response: 'accepted' | 'declined' | 'cancelled',
    source: string = 'pwa'
  ) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || '{}');
    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    const buildRequest = (authToken: string) => {
      const headers = new HttpHeaders()
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .set('Authorization', authToken);
      const params = new HttpParams()
        .set('event_id', eventId.toString())
     //   .set('user_id', userId.toString())
        .set('host_id', hostId.toString())
        .set('event_name', eventName)
        .set('user_name', userName)
        .set('transition_request_id', transitionRequestId.toString())
        .set('response', response)
        .set('source', source);
      return this.http.post(
        'https://welg73xsvd.execute-api.us-west-1.amazonaws.com/default/host-transition-response',
        params.toString(),
        { headers }
      );
    };

    if (this.userCurrentTime < this.userExpirationTime) {
      return buildRequest(token);
    } else {
      const refToken = await requestToken(this.afAuth);
      if (refToken) this.refToken = refToken;
      return buildRequest(this.refToken);
    }
  }

  async exitEvent(eventId: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("event_id", eventId.toString());
      // .set("collaborator_id", user_id.toString());

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://ht6nebrfob.execute-api.us-west-1.amazonaws.com/pwa-exit-event",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", eventId.toString());
      // .set("collaborator_id", user_id.toString());
      return this.http.post(
        "https://ht6nebrfob.execute-api.us-west-1.amazonaws.com/pwa-exit-event",
        params.toString(),
        { headers }
      );
    }
  }

  async changeCover(eventId: any, fileId: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("file_id", fileId.toString());

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://s2zoth0e42.execute-api.us-west-1.amazonaws.com/pwa-change-cover",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("file_id", fileId.toString());
      return this.http.post(
        "https://s2zoth0e42.execute-api.us-west-1.amazonaws.com/pwa-change-cover",
        params.toString(),
        { headers }
      );
    }
  }

  async deleteEvent(eventId: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("event_id", eventId.toString());

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://y2a2fzhhp9.execute-api.us-west-1.amazonaws.com/pwa-delete-event",
        params.toString(),
        { headers }
      ).pipe(tap(() => this.uploadBanner.eventDeleted(eventId)));
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", eventId.toString());
      return this.http.post(
        "https://y2a2fzhhp9.execute-api.us-west-1.amazonaws.com/pwa-delete-event",
        params.toString(),
        { headers }
      ).pipe(tap(() => this.uploadBanner.eventDeleted(eventId)));
    }
  }




  async deleteScheduledEvent(eventID: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("event_id", eventID);
      return this.http.get(
        "https://7yqrx2srej.execute-api.us-west-1.amazonaws.com/pwa_delete_scheduled_event",
        { headers }
      );

    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("event_id", eventID);

      return this.http.get(
        "https://7yqrx2srej.execute-api.us-west-1.amazonaws.com/pwa_delete_scheduled_event",
        { headers }
      );

    }
  }

  /**
   * The Picaggo stock cover gallery.
   *
   * Static content, identical for every user, so it goes through
   * ApiCacheService rather than a bare http.get: the CacheStorage copy paints
   * the grid the moment the picker opens and the network response replaces it
   * when it lands. Previously this refetched in full on every open of the
   * cover picker, from all six screens that offer one.
   *
   * Returns the Observable directly rather than a Promise wrapping one. The
   * old signature made the caller `await` before it could even subscribe, and
   * on an expired token that await was a whole Firebase round trip spent
   * before the request was issued — the token work now happens inside the
   * subscription instead.
   */
  fetchDefaultImage(): Observable<any> {
    const url = "https://cwul1tzh28.execute-api.us-west-1.amazonaws.com/pwa_fetch_default_image";

    return new Observable<any>((observer) => {
      this.encryptedData = localStorage.getItem('user');
      this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
      const user = JSON.parse(this.decryptedData || "{}");
      const token: any = user?.stsTokenManager?.accessToken;
      const expirationTime = user?.stsTokenManager?.expirationTime;

      this.userCurrentTime = new Date();
      this.userExpirationTime = new Date(expirationTime);

      let inner: Subscription | null = null;

      const proceed = (finalToken: string) => {
        const headers = new HttpHeaders()
          .set("Content-Type", "application/x-www-form-urlencoded")
          .set("Authorization", finalToken);

        inner = this.apiCache.getData<any>(url, { headers }).subscribe({
          // The cache seeds its subject with null before anything is loaded.
          // Passing that on would flip the picker out of its loading state
          // with no images to show, so hold it back and let only the real
          // payload — cached copy first, then network — through.
          next: (data) => { if (data != null) observer.next(data); },
          error: (err) => observer.error(err),
        });
      };

      if (this.userCurrentTime < this.userExpirationTime) {
        proceed(token);
      } else {
        requestToken(this.afAuth).then((refToken) => {
          if (refToken) {
            this.refToken = refToken;
            proceed(this.refToken);
          } else {
            observer.error(new Error('No auth token available'));
          }
        });
      }

      // The cache's subject never completes, so without this the picker would
      // leave a live subscription behind on every open.
      return () => inner?.unsubscribe();
    });
  }

  async getHexStatus(hex: any): Promise<Observable<any>> {

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("hex", hex)
      return this.http.get(
        "https://6hhmsmv6ka.execute-api.us-west-1.amazonaws.com/pwa-check-hex-event-detail",
        { headers }
      );

    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("hex", hex);

      return this.http.get(
        "https://6hhmsmv6ka.execute-api.us-west-1.amazonaws.com/pwa-check-hex-event-detail",
        { headers }
      );

    }
  }

  async getPublicUrl(hex: any): Promise<Observable<any>> {

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("hex", hex)
      return this.http.get(
        "https://rybilgjvb2.execute-api.us-west-1.amazonaws.com/pwa_get_url",
        { headers }
      );

    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("hex", hex);

      return this.http.get(
        "https://rybilgjvb2.execute-api.us-west-1.amazonaws.com/pwa_get_url",
        { headers }
      );

    }
  }

  async addRestrictedUser(hex: any) {

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("hex", localStorage.getItem("eventId") || hex)
      return this.http.get(
        "https://15c73ncfx1.execute-api.us-west-1.amazonaws.com/add-restricted-user",
        { headers }
      );

    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("hex", localStorage.getItem("eventId") || hex);

      return this.http.get(
        "https://15c73ncfx1.execute-api.us-west-1.amazonaws.com/add-restricted-user",
        { headers }
      );

    }
  }

  async getAllLiveEvents(max: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    // const user = JSON.parse(jsonString);
    //  console.log({ user });

    if (user?.isAnonymous) {
      const token: any = user?.stsTokenManager?.accessToken;
      // Add for AccessToken get
      const expirationTime = user?.stsTokenManager?.expirationTime;
      const currentTime = new Date().getTime() / 1000;
      this.userCurrentTime = new Date(currentTime * 1000);
      this.userExpirationTime = new Date(expirationTime);
      if (this.userCurrentTime < this.userExpirationTime) {
        const options = {
          headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded")
            .set("Authorization", token)
            .set("hex", localStorage.getItem("eventId") || "{}")
            .set("min", '0')
            .set("max", max)
        };
        return this.http.get(
          "https://lum55h57wi.execute-api.us-west-1.amazonaws.com/fetch_live_event_content",
          options
        );
      } else {
        // call utils function for token request
        const Reftoken = await requestToken(this.afAuth);
        if (Reftoken) {
          //   console.log(Reftoken);  
          this.refToken = Reftoken;
        }
        const options = {
          headers: new HttpHeaders()
            .set("Content-Type", "application/x-www-form-urlencoded")
            .set("Authorization", this.refToken).set("hex", localStorage.getItem("eventId") || "{}")
            .set("min", '0')
            .set("max", max)
        };
        return this.http.get(
          "https://lum55h57wi.execute-api.us-west-1.amazonaws.com/fetch_live_event_content",
          options
        );
      }
    } else {
      this.encryptedData = localStorage.getItem('user');
      this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
      const user = JSON.parse(this.decryptedData || "{}");
      // Parse the JSON string
      //const user = JSON.parse(jsonString);
      // console.log({ user });
      //const user = JSON.parse(localStorage.getItem("user") || "{}");
      const token: any = user?.stsTokenManager?.accessToken;
      // Add for AccessToken get
      const expirationTime = user?.stsTokenManager?.expirationTime;
      const currentTime = new Date().getTime() / 1000;
      this.userCurrentTime = new Date(currentTime * 1000);
      this.userExpirationTime = new Date(expirationTime);
      // set headers
      if (this.userCurrentTime < this.userExpirationTime) {
        const headers = new HttpHeaders()
          .set("Content-Type", "application/x-www-form-urlencoded")
          .set("Authorization", token)
          .set("hex", localStorage.getItem("eventId") || "{}")
          .set("min", '0')
          .set("max", max)
          .set("user_id", '0');

        return this.http.get(
          "https://lum55h57wi.execute-api.us-west-1.amazonaws.com/fetch_live_event_content",
          { headers }
        );
      } else {
        // call utils function for token request
        const Reftoken = requestToken(token);
        if (token) {
          this.refToken = token;
        }
        const headers = new HttpHeaders()
          .set("Content-Type", "application/x-www-form-urlencoded")
          .set("Authorization", this.refToken);

        return this.http.get(
          "https://lum55h57wi.execute-api.us-west-1.amazonaws.com/fetch_live_event_content",
          { headers }
        );
      }
    }
  }


  async getawsCreds() {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    // console.log({ user });
    //const user = JSON.parse(localStorage.getItem("user") || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);

      return this.http.get(
        "https://hrbe8t7hfe.execute-api.us-west-1.amazonaws.com/dev/pwa_get_upload_urls",
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = requestToken(token);
      if (token) {
        this.refToken = token;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);

      return this.http.get(
        "https://hrbe8t7hfe.execute-api.us-west-1.amazonaws.com/dev/pwa_get_upload_urls",
        { headers }
      );
    }
  }



  async getAllEventsByCategory(categoryId: any, max: any, min: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    // const user = JSON.parse(jsonString);
    // console.log({ min }); //__CONSOLE_LOG__
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("category_id", categoryId.toString())
        .set("min", min.toString())
        .set("max", max.toString());
      return this.http.get(
        "https://x2us8owmqe.execute-api.us-west-1.amazonaws.com/pwa_fetch_events_by_category",
        { headers }
      );
    } else {
      // console.log('token expired, requesting new token'); //__CONSOLE_LOG__

      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("category_id", categoryId)
        .set("min", min.toString())
        .set("max", max.toString());
      return this.http.get(
        "https://x2us8owmqe.execute-api.us-west-1.amazonaws.com/pwa_fetch_events_by_category",
        { headers }
      );
    }
  }

  async getAllEvents(max: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    // const user = JSON.parse(jsonString);
    //console.log({ user });
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("min", '0')
        .set("max", max);
      return this.http.get(
        "https://jqsmbrhzh6.execute-api.us-west-1.amazonaws.com/pwa_fetch_events",
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("min", '0')
        .set("max", max);
      return this.http.get(
        "https://jqsmbrhzh6.execute-api.us-west-1.amazonaws.com/pwa_fetch_events",
        { headers }
      );
    }
  }

  async getEventList() {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");

    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);

      return this.http.get(
        "https://pdmv73lyej.execute-api.us-west-1.amazonaws.com/pwa_get_eventlist",
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      return this.http.get(
        "https://pdmv73lyej.execute-api.us-west-1.amazonaws.com/pwa_get_eventlist",
        { headers }
      );
    }
  }

  async getEventStorageList() {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");

    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      return this.http.get(
        "https://7uw7jglpaj.execute-api.us-west-1.amazonaws.com/default/pwa-get-event-storage",
        { headers }
      );
    } else {
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) { this.refToken = Reftoken; }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      return this.http.get(
        "https://7uw7jglpaj.execute-api.us-west-1.amazonaws.com/default/pwa-get-event-storage",
        { headers }
      );
    }
  }

  async getPaymentLogs() {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");

    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);

      return this.http.get(
        "https://xadycik2ye.execute-api.us-west-1.amazonaws.com/pwa_fetch_payment_logs",
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      return this.http.get(
        "https://xadycik2ye.execute-api.us-west-1.amazonaws.com/pwa_fetch_payment_logs",
        { headers }
      );
    }
  }


  // async getHomePageData(max: any, min: any) {
  //   this.encryptedData = localStorage.getItem('user');
  //   this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
  //   const user = JSON.parse(this.decryptedData || "{}");
  //   // Parse the JSON string
  //   // const user = JSON.parse(jsonString);
  //   //console.log({ user });
  //   const token: any = user?.stsTokenManager?.accessToken;
  //   // Add for AccessToken get
  //   const expirationTime = user?.stsTokenManager?.expirationTime;
  //   const currentTime = new Date().getTime() / 1000;
  //   this.userCurrentTime = new Date(currentTime * 1000);
  //   this.userExpirationTime = new Date(expirationTime);
  //   // set headers
  //   if (this.userCurrentTime < this.userExpirationTime) {
  //     const headers = new HttpHeaders()
  //       .set("Content-Type", "application/x-www-form-urlencoded")
  //       .set("Authorization", token)
  //       .set("min", min.toString())
  //       .set("max", max.toString());
  //     return this.http.get(
  //       // "https://zpiisipwdk.execute-api.us-west-1.amazonaws.com/test/pwa_get_home_page_data",
  //       "https://yvmxlr61n9.execute-api.us-west-1.amazonaws.com/pwa_get_home_page_data",
  //       { headers }
  //     );
  //   } else {
  //     // call utils function for token request
  //     const Reftoken = await requestToken(this.afAuth);
  //     if (Reftoken) {
  //       // console.log(Reftoken); //__CONSOLE_LOG__
  //       this.refToken = Reftoken;
  //     }
  //     const headers = new HttpHeaders()
  //       .set("Content-Type", "application/x-www-form-urlencoded")
  //       .set("Authorization", this.refToken)
  //       .set("min", min.toString())
  //       .set("max", max.toString());
  //     return this.http.get(
  //       //"https://zpiisipwdk.execute-api.us-west-1.amazonaws.com/test/pwa_get_home_page_data",
  //       "https://yvmxlr61n9.execute-api.us-west-1.amazonaws.com/pwa_get_home_page_data",
  //       { headers }
  //     );
  //   }
  // }

  getHomePageData1(max: any, min: any): Observable<any> {
    const url = 'https://yvmxlr61n9.execute-api.us-west-1.amazonaws.com/pwa_get_home_page_data';

    return new Observable((observer) => {
      this.encryptedData = localStorage.getItem('user');
      let user: any = {};
      try {
        this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
        user = JSON.parse(this.decryptedData || '{}');
      } catch {
        user = {};
      }

      const storedToken: string | null = user?.stsTokenManager?.accessToken || null;
      const expirationTime: number = Number(user?.stsTokenManager?.expirationTime || 0);
      // Milliseconds, like stsTokenManager.expirationTime. This was in seconds,
      // so every stored token looked valid forever: an expired one went out,
      // got a 401 that ApiCacheService swallows, and Home stayed empty until
      // the user signed out and back in.
      const currentTime = Date.now();

      const proceed = (finalToken: string | null) => {
        if (!finalToken) {
          observer.error(new Error('Unable to obtain Firebase token for getHomePageData1'));
          observer.complete();
          return;
        }

        const headers = new HttpHeaders()
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('Authorization', finalToken)
          .set('min', min.toString())
          .set('max', max.toString());

        this.apiCache.getData<any>(`${url}?min=${min}&max=${max}`, { headers }).subscribe({
          next: (data) => observer.next(data),
          error: (err) => observer.error(err),
          complete: () => observer.complete()
        });
      };

      if (storedToken && expirationTime > currentTime) {
        proceed(storedToken);
      } else {
        requestToken(this.afAuth).then((refToken) => {
          if (refToken) {
            this.refToken = refToken;
          }
          proceed(this.refToken);
        }).catch((err) => {
          observer.error(err);
          observer.complete();
        });
      }
    });
  }

  getHomePageData(max: any, min: any): Observable<any> {
    const url = 'https://yvmxlr61n9.execute-api.us-west-1.amazonaws.com/pwa_get_home_page_data';

    return new Observable((observer) => {
      this.encryptedData = localStorage.getItem('user');
      let user: any = {};
      try {
        this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
        user = JSON.parse(this.decryptedData || '{}');
      } catch {
        user = {};
      }

      const storedToken: string | null = user?.stsTokenManager?.accessToken || null;
      const expirationTime: number = Number(user?.stsTokenManager?.expirationTime || 0);
      // Milliseconds, like stsTokenManager.expirationTime. This was in seconds,
      // so every stored token looked valid forever: an expired one went out,
      // got a 401 that ApiCacheService swallows, and Home stayed empty until
      // the user signed out and back in.
      const currentTime = Date.now();

      // ✅ Pick UID for user-specific cache key
      const userId = user?.uid || 'guest';

      const proceed = (finalToken: string | null) => {
        if (!finalToken) {
          observer.error(new Error('Unable to obtain Firebase token for getHomePageData'));
          observer.complete();
          return;
        }

        const headers = new HttpHeaders()
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('Authorization', finalToken)
          .set('min', min.toString())
          .set('max', max.toString());

        const cacheKey = `${url}?uid=${userId}&min=${min}&max=${max}`;

        this.apiCache.getData<any>(cacheKey, { headers }).subscribe({
          next: (data) => observer.next(data),
          error: (err) => observer.error(err),
          complete: () => observer.complete()
        });
      };

      if (storedToken && expirationTime > currentTime) {
        proceed(storedToken);
      } else {
        requestToken(this.afAuth).then((refToken) => {
          if (refToken) {
            this.refToken = refToken;
          }
          proceed(this.refToken);
        }).catch((err) => {
          observer.error(err);
          observer.complete();
        });
      }
    });
  }



  async getPublicHomePageData(max: any, min: any) {
    const headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("i", '464631c94957f2e1464d5af12aeee3d5')
      .set("min", min.toString())
      .set("max", max.toString());
    return this.http.get(
      "https://zxxfxnxlo3.execute-api.us-west-1.amazonaws.com/pwa_public_home_page_data",
      { headers }
    );
  }


  async getSearchData(max: any, min: any, searchTerm: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    // const user = JSON.parse(jsonString);
    //console.log({ user });
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        //   .set("user_id", user_id.toString())
        // Encoded: browsers refuse header values outside Latin-1, so Hindi or emoji searches never left the device
        .set("keyword", encodeURIComponent(searchTerm.toString()))
        .set("min", min.toString())
        .set("max", max.toString());
      return this.http.get(
        "https://kkppndalzg.execute-api.us-west-1.amazonaws.com/pwa_search_events",
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        // console.log(Reftoken); //__CONSOLE_LOG__
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        // .set("user_id", user_id.toString())
        .set("keyword", encodeURIComponent(searchTerm.toString()))
        .set("min", min.toString())
        .set("max", max.toString());
      return this.http.get(
        "https://kkppndalzg.execute-api.us-west-1.amazonaws.com/pwa_search_events",
        { headers }
      );
    }
  }

  // async getMyPictures(min: any, max: any, event_id: any): Promise<Observable<any>> {
  //   this.encryptedData = localStorage.getItem('user');
  //   this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
  //   const user = JSON.parse(this.decryptedData || "{}");
  //   // Parse the JSON string
  //   // const user = JSON.parse(jsonString);
  //   //console.log({ user });
  //   const token: any = user?.stsTokenManager?.accessToken;
  //   // Add for AccessToken get
  //   const expirationTime = user?.stsTokenManager?.expirationTime;
  //   const currentTime = new Date().getTime() / 1000;
  //   this.userCurrentTime = new Date(currentTime * 1000);
  //   this.userExpirationTime = new Date(expirationTime);
  //   // set headers
  //   if (this.userCurrentTime < this.userExpirationTime) {
  //     const headers = new HttpHeaders()
  //       .set("Content-Type", "application/x-www-form-urlencoded")
  //       .set("Authorization", token)
  //       .set("sortingOrder", '1')
  //       .set("event_id", event_id.toString())
  //       .set("min", min.toString())
  //       .set("max", max.toString());
  //     return this.http.get(
  //       "https://brepi0e3li.execute-api.us-west-1.amazonaws.com/pwa_search_my_pictures",
  //       { headers }
  //     );
  //   } else {
  //     // call utils function for token request
  //     const Reftoken = await requestToken(this.afAuth);
  //     if (Reftoken) {
  //       console.log(Reftoken);
  //       this.refToken = Reftoken;
  //     }
  //     const headers = new HttpHeaders()
  //       .set("Content-Type", "application/x-www-form-urlencoded")
  //       .set("Authorization", this.refToken)
  //       .set("sortingOrder", '1')
  //       .set("keyword", event_id.toString())
  //       .set("min", min.toString())
  //       .set("max", max.toString());
  //     return this.http.get(
  //       "https://brepi0e3li.execute-api.us-west-1.amazonaws.com/pwa_search_my_pictures",
  //       { headers }
  //     );
  //   }
  // }
  async getMyPictures(min: any, max: any, event_hex: any, mediaType: any, subFolder: any, sortingOrder: any): Promise<Observable<any>> {
    if (sortingOrder == 'asc') {
      sortingOrder = 0;
    }
    else {
      sortingOrder = 1;
    }

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    // const user = JSON.parse(jsonString);
    //console.log({ user });
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("sortingOrder", sortingOrder.toString())
        .set("event_hex", event_hex.toString())
        .set("min", min.toString())
        .set("max", max.toString())
        .set("mediaType", mediaType.toString())
        .set("subfolder_id", subFolder.toString());
      return this.http.get(
        "https://jkdwpu4ipd.execute-api.us-west-1.amazonaws.com/pwa_search_my_pictures_hex",
        // "https://apz9msfgy2.execute-api.us-west-1.amazonaws.com/dev/test-pwa-search-my-pictures",
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        // console.log(Reftoken); //__CONSOLE_LOG__
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("sortingOrder", sortingOrder.toString())
        .set("event_hex", event_hex.toString())
        .set("min", min.toString())
        .set("max", max.toString())
        .set("mediaType", mediaType.toString())
        .set("subfolder_id", subFolder.toString());
      return this.http.get(
        "https://jkdwpu4ipd.execute-api.us-west-1.amazonaws.com/pwa_search_my_pictures_hex",
        { headers }
      );
    }
  }



  async getMySelfies(min: any, max: any, event_hex: any, mediaType: any, subFolder: any, sortingOrder: any, event_id: any): Promise<Observable<any>> {
    if (sortingOrder == 'asc') {
      sortingOrder = 0;
    }
    else {
      sortingOrder = 1;
    }

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    // const user = JSON.parse(jsonString);
    //console.log({ user });
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("sortingOrder", sortingOrder.toString())
        .set("event_hex", event_hex.toString())
        .set("min", min.toString())
        .set("max", max.toString())
        .set("mediaType", mediaType.toString())
        .set("subfolder_id", subFolder.toString())
        .set("event_id", event_id.toString());
      return this.http.get(
        "https://cs7mdc1iih.execute-api.us-west-1.amazonaws.com/pwa_selfie_search",
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        // console.log(Reftoken); //__CONSOLE_LOG__
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("sortingOrder", sortingOrder.toString())
        .set("event_hex", event_hex.toString())
        .set("min", min.toString())
        .set("max", max.toString())
        .set("mediaType", mediaType.toString())
        .set("subfolder_id", subFolder.toString())
        .set("event_id", event_id.toString());
      return this.http.get(
        "https://cs7mdc1iih.execute-api.us-west-1.amazonaws.com/pwa_selfie_search",
        { headers }
      );
    }
  }

  sanitizeHeaderValue(value: string): string {
    // replace non-ISO-8859-1 characters with '?'
    return value.replace(/[^\u0000-\u00FF]/g, '?');
  }

  async generateAIresponse(action: any, event_name: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");

    // Parse the JSON string
    // const user = JSON.parse(jsonString);

    const token: any = user?.stsTokenManager?.accessToken;
    //console.log(token);
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      // console.log('token valid'); //__CONSOLE_LOG__

      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("action", action.toString())
        .set("event_name", this.sanitizeHeaderValue(event_name.toString()))
      return this.http.get(
        "https://l96jrk0nm2.execute-api.us-west-1.amazonaws.com/generate-response",
        { headers }
      );
    } else {
      // console.log('token expired'); //__CONSOLE_LOG__
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("action", action.toString())
        .set("event_name", event_name.toString())
      return this.http.get(
        "https://l96jrk0nm2.execute-api.us-west-1.amazonaws.com/generate-response",
        { headers }
      );
    }
  }


  getTotalCategory(): Observable<any> {
    const url = 'https://02l1hwixc6.execute-api.us-west-1.amazonaws.com/pwa_get_total_categories';

    // We'll let ApiCacheService + SW handle caching
    return new Observable((observer) => {
      this.encryptedData = localStorage.getItem('user');
      this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
      const user = JSON.parse(this.decryptedData || '{}');

      const token: any = user?.stsTokenManager?.accessToken;
      const expirationTime = user?.stsTokenManager?.expirationTime;
      const currentTime = new Date().getTime() / 1000;

      this.userCurrentTime = new Date(currentTime * 1000);
      this.userExpirationTime = new Date(expirationTime);

      const proceed = (finalToken: string) => {
        const headers = new HttpHeaders()
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('Authorization', finalToken);

        // Use ApiCacheService to fetch with stale-while-revalidate
        this.apiCache.getData<any>(url, { headers }).subscribe({
          next: (data) => observer.next(data),
          error: (err) => observer.error(err),
          complete: () => observer.complete()
        });
      };

      if (this.userCurrentTime < this.userExpirationTime) {
        proceed(token);
      } else {
        requestToken(this.afAuth).then((refToken) => {
          if (refToken) this.refToken = refToken;
          proceed(this.refToken);
        });
      }
    });
  }

  // getTotalCategory() {
  //   this.encryptedData = localStorage.getItem('user');
  //   this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
  //   const user = JSON.parse(this.decryptedData || "{}");

  //   const token: any = user?.stsTokenManager?.accessToken;
  //   const expirationTime = user?.stsTokenManager?.expirationTime;
  //   const currentTime = new Date().getTime() / 1000;

  //   this.userCurrentTime = new Date(currentTime * 1000);
  //   this.userExpirationTime = new Date(expirationTime);

  //   if (this.userCurrentTime < this.userExpirationTime) {
  //     const headers = new HttpHeaders()
  //       .set("Content-Type", "application/x-www-form-urlencoded")
  //       .set("Authorization", token);

  //     return this.http.get("https://02l1hwixc6.execute-api.us-west-1.amazonaws.com/pwa_get_total_categories", { headers });

  //   } else {
  //     return new Observable((observer) => {
  //       requestToken(this.afAuth).then((Reftoken) => {
  //         if (Reftoken) this.refToken = Reftoken;
  //         const headers = new HttpHeaders()
  //           .set("Content-Type", "application/x-www-form-urlencoded")
  //           .set("Authorization", this.refToken);

  //         this.http.get("https://02l1hwixc6.execute-api.us-west-1.amazonaws.com/pwa_get_total_categories", { headers })
  //           .subscribe({
  //             next: (res) => {
  //               observer.next(res);
  //               observer.complete();
  //             },
  //             error: (err) => observer.error(err)
  //           });
  //       });
  //     });
  //   }
  // }


  async getPublicTotalCategory() {
    const headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("i", '464631c94957f2e1464d5af12aeee3d5')
    return this.http.get(
      "https://p5hkh6gczh.execute-api.us-west-1.amazonaws.com/pwa_get_public_total_categories",
      { headers }
    );

  }

  getTempUrl(key: any): Observable<any> {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("key", key.toString())
      //console.log({ headers });

      return this.http.get(
        //"https://f55a6falwe.execute-api.us-west-1.amazonaws.com/test/pwa_fetch_media",
        "https://gj8j07b9oa.execute-api.us-west-1.amazonaws.com/pwa_get_temp_url",
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("key", key.toString());

      return this.http.get(
        // "https://f55a6falwe.execute-api.us-west-1.amazonaws.com/test/pwa_fetch_media",
        "https://gj8j07b9oa.execute-api.us-west-1.amazonaws.com/pwa_get_temp_url",
        { headers }
      );
    }
  }

  moveOriginals(event_id: any): Observable<any> {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("event_id", event_id.toString())
      //console.log({ headers });

      return this.http.get(
        //"https://f55a6falwe.execute-api.us-west-1.amazonaws.com/test/pwa_fetch_media",
        "https://r1o4mws9h7.execute-api.us-west-1.amazonaws.com/pwa_move_originals",
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("event_id", event_id.toString());

      return this.http.get(
        // "https://f55a6falwe.execute-api.us-west-1.amazonaws.com/test/pwa_fetch_media",
        "https://r1o4mws9h7.execute-api.us-west-1.amazonaws.com/pwa_move_originals",
        { headers }
      );
    }
  }


  getTotalMediaCount(hex: any): Observable<any> {
    const url = "https://n7lrsuh3vi.execute-api.us-west-1.amazonaws.com/pwa_get_media_count";

    return new Observable((observer) => {
      this.encryptedData = localStorage.getItem('user');
      let user: any = {};
      try {
        this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
        user = JSON.parse(this.decryptedData || "{}");
      } catch {
        user = {};
      }

      const storedToken: string | null = user?.stsTokenManager?.accessToken || null;
      const expirationTime: number = Number(user?.stsTokenManager?.expirationTime || 0);
      // Milliseconds, like stsTokenManager.expirationTime. This was in seconds,
      // so every stored token looked valid forever: an expired one went out,
      // got a 401 that ApiCacheService swallows, and Home stayed empty until
      // the user signed out and back in.
      const currentTime = Date.now();

      const fetchWithToken = (finalToken: string | null) => {
        if (!finalToken) {
          observer.error(new Error('Unable to obtain Firebase token for getMediaCount'));
          observer.complete();
          return;
        }

        const headers = new HttpHeaders()
          .set("Content-Type", "application/x-www-form-urlencoded")
          .set("Authorization", finalToken)
          .set("hex", hex);

        this.apiCache.getData<any>(`${url}?hex=${hex}`, { headers }).subscribe({
          next: (data) => observer.next(data),
          error: (err) => observer.error(err),
          complete: () => observer.complete()
        });
      };

      if (storedToken && expirationTime > currentTime) {
        fetchWithToken(storedToken);
      } else {
        requestToken(this.afAuth).then((refToken) => {
          if (refToken) {
            this.refToken = refToken;
          }
          fetchWithToken(this.refToken);
        }).catch((err) => {
          observer.error(err);
          observer.complete();
        });
      }
    });
  }

  /**
   * Get fresh media count data, bypassing cache
   * Use this after updating event details to ensure latest data
   */
  getTotalMediaCountFresh(hex: any): Observable<any> {
    const url = "https://n7lrsuh3vi.execute-api.us-west-1.amazonaws.com/pwa_get_media_count";

    return new Observable((observer) => {
      this.encryptedData = localStorage.getItem('user');
      this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
      let user: any = {};
      try {
        user = JSON.parse(this.decryptedData || "{}");
      } catch {
        user = {};
      }

      const storedToken: string | null = user?.stsTokenManager?.accessToken || null;
      const expirationTime: number = Number(user?.stsTokenManager?.expirationTime || 0);
      // Milliseconds, like stsTokenManager.expirationTime. This was in seconds,
      // so every stored token looked valid forever: an expired one went out,
      // got a 401 that ApiCacheService swallows, and Home stayed empty until
      // the user signed out and back in.
      const currentTime = Date.now();

      const fetchWithToken = (finalToken: string | null) => {
        if (!finalToken) {
          observer.error(new Error('Unable to obtain Firebase token for getMediaCountFresh'));
          observer.complete();
          return;
        }

        const headers = new HttpHeaders()
          .set("Content-Type", "application/x-www-form-urlencoded")
          .set("Authorization", finalToken)
          .set("hex", hex);

        this.apiCache.clearMediaCountCache();

        this.apiCache.getFreshData<any>(`${url}?hex=${hex}`, { headers }).subscribe({
          next: (data) => observer.next(data),
          error: (err) => observer.error(err),
          complete: () => observer.complete()
        });
      };

      if (storedToken && expirationTime > currentTime) {
        fetchWithToken(storedToken);
      } else {
        requestToken(this.afAuth).then((refToken) => {
          if (refToken) {
            this.refToken = refToken;
          }
          fetchWithToken(this.refToken);
        }).catch((err) => {
          observer.error(err);
          observer.complete();
        });
      }
    });
  }

  // async getTotalMediaCount(hex: any) {
  //   this.encryptedData = localStorage.getItem('user');
  //   this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
  //   const user = JSON.parse(this.decryptedData || "{}");
  //   // Parse the JSON string
  //   // const user = JSON.parse(jsonString);
  //   //console.log({ user });
  //   const token: any = user?.stsTokenManager?.accessToken;
  //   // Add for AccessToken get
  //   const expirationTime = user?.stsTokenManager?.expirationTime;
  //   const currentTime = new Date().getTime() / 1000;
  //   this.userCurrentTime = new Date(currentTime * 1000);
  //   this.userExpirationTime = new Date(expirationTime);
  //   // set headers
  //   if (this.userCurrentTime < this.userExpirationTime) {
  //     const headers = new HttpHeaders()
  //       .set("Content-Type", "application/x-www-form-urlencoded")
  //       .set("Authorization", token)
  //       .set("hex", hex)
  //     return this.http.get(
  //       "https://n7lrsuh3vi.execute-api.us-west-1.amazonaws.com/pwa_get_media_count",
  //       { headers }
  //     );
  //   } else {
  //     // call utils function for token request
  //     const Reftoken = await requestToken(this.afAuth);
  //     if (Reftoken) {
  //       //   console.log(Reftoken);  
  //       this.refToken = Reftoken;
  //     }
  //     const headers = new HttpHeaders()
  //       .set("Content-Type", "application/x-www-form-urlencoded")
  //       .set("Authorization", this.refToken)
  //       .set("hex", hex)
  //     return this.http.get(
  //       "https://n7lrsuh3vi.execute-api.us-west-1.amazonaws.com/pwa_get_media_count",
  //       { headers }
  //     );
  //   }
  // }



  async saveAlbumComment(eventId: any, comment: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("comment", comment.toString());

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://j65eppgqk3.execute-api.us-west-1.amazonaws.com/pwa_save_album_comment",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("comment", comment.toString());
      return this.http.post(
        "https://j65eppgqk3.execute-api.us-west-1.amazonaws.com/pwa_save_album_comment",
        params.toString(),
        { headers }
      );
    }
  }


  async saveGuestbookEntry(payload: any): Promise<Observable<any>> {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", token);

      return this.http.post(
        "https://13meff00pl.execute-api.us-west-1.amazonaws.com/default/pwa-save-guestbook-entry",
        payload,
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", this.refToken);

      return this.http.post(
        "https://13meff00pl.execute-api.us-west-1.amazonaws.com/default/pwa-save-guestbook-entry",
        payload,
        { headers }
      );
    }
  }

  async updateGuestbookEntry(payload: any): Promise<Observable<any>> {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", token);

      return this.http.post(
        "https://hd55but4g6.execute-api.us-west-1.amazonaws.com/default/pwa-update-guestbook-entry",
        payload,
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", this.refToken);

      return this.http.post(
        "https://hd55but4g6.execute-api.us-west-1.amazonaws.com/default/pwa-update-guestbook-entry",
        payload,
        { headers }
      );
    }
  }

  async fetchGuestbookEntries(eventId: string): Promise<Observable<any>> {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("event_id", eventId);

      return this.http.get(
        "https://md9p9q8rai.execute-api.us-west-1.amazonaws.com/default/pwa-fetch-guestbook-entries",
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("event_id", eventId);

      return this.http.get(
        "https://md9p9q8rai.execute-api.us-west-1.amazonaws.com/default/pwa-fetch-guestbook-entries",
        { headers }
      );
    }
  }

  // async saveDefaultGalleryTab(eventId: string, defaultTab: string): Promise<Observable<any>> {
  //   this.encryptedData = localStorage.getItem('user');
  //   this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
  //   const user = JSON.parse(this.decryptedData || "{}");
  //   const token: any = user?.stsTokenManager?.accessToken;
  //   const expirationTime = user?.stsTokenManager?.expirationTime;
  //   const currentTime = new Date().getTime() / 1000;
  //   this.userCurrentTime = new Date(currentTime * 1000);
  //   this.userExpirationTime = new Date(expirationTime);

  //   const payload = {
  //     event_id: eventId,
  //     default_gallery_tab: defaultTab
  //   };

  //   if (this.userCurrentTime < this.userExpirationTime) {
  //     const headers = new HttpHeaders()
  //       .set("Content-Type", "application/json")
  //       .set("Authorization", token);

  //     return this.http.post(
  //       "https://13meff00pl.execute-api.us-west-1.amazonaws.com/default/pwa-save-default-gallery-tab",
  //       payload,
  //       { headers }
  //     );
  //   } else {
  //     const Reftoken = await requestToken(this.afAuth);
  //     if (Reftoken) {
  //       this.refToken = Reftoken;
  //     }
  //     const headers = new HttpHeaders()
  //       .set("Content-Type", "application/json")
  //       .set("Authorization", this.refToken);

  //     return this.http.post(
  //       "https://13meff00pl.execute-api.us-west-1.amazonaws.com/default/pwa-save-default-gallery-tab",
  //       payload,
  //       { headers }
  //     );
  //   }
  // }

  async deleteGuestbookEntry(entryId: string, eventId: string): Promise<Observable<any>> {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    const payload = {
      entry_id: entryId,
      event_id: eventId
    };

    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", token);

      return this.http.post(
        "https://8jspc1d2bb.execute-api.us-west-1.amazonaws.com/default/pwa-delete-guestbook-entry",
        payload,
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", this.refToken);

      return this.http.post(
        "https://8jspc1d2bb.execute-api.us-west-1.amazonaws.com/default/pwa-delete-guestbook-entry",
        payload,
        { headers }
      );
    }
  }

  async getSelfie(): Promise<Observable<any>> {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    // const user = JSON.parse(jsonString);
    //console.log({ user });
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
      return this.http.get(
        "https://b2tgo1c643.execute-api.us-west-1.amazonaws.com/pwa_get_user_image",
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
      return this.http.get(
        "https://b2tgo1c643.execute-api.us-west-1.amazonaws.com/pwa_get_user_image",
        { headers }
      );
    }
  }

  async getSelfieMyPhotos(event_id: any): Promise<Observable<any>> {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    // const user = JSON.parse(jsonString);
    //console.log({ user });
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("event_id", event_id.toString());
      return this.http.get(
        "https://1o3z6hl9ej.execute-api.us-west-1.amazonaws.com/pwa_get_user_image_myphotos",
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("event_id", event_id.toString());

      return this.http.get(
        "https://1o3z6hl9ej.execute-api.us-west-1.amazonaws.com/pwa_get_user_image_myphotos",
        { headers }
      );
    }
  }

  goBack() {

    if (localStorage.getItem('eventId')) {
      localStorage.removeItem('eventId');
    }

    if (localStorage.getItem('isEventId')) {
      localStorage.removeItem('isEventId');
    }
    if (localStorage.getItem('event_hash')) {
      localStorage.removeItem('event_hash');
    }

    if (localStorage.getItem('event_name')) {
      localStorage.removeItem('event_name');
    }

    if (localStorage.getItem('e')) {
      localStorage.removeItem('e');
    }

    if (localStorage.getItem('isHost')) {
      localStorage.removeItem('isHost');
    }

    if (localStorage.getItem('inviteData')) {
      localStorage.removeItem('inviteData');
    }

    if (localStorage.getItem('eventData')) {
      localStorage.removeItem('eventData');
    }

    if (localStorage.getItem('isScheduled')) {
      localStorage.removeItem('isScheduled');
    }

    if (localStorage.getItem('qrcode')) {
      localStorage.removeItem('qrcode');
    }
    if (localStorage.getItem('savedHashtags')) {
      localStorage.removeItem('savedHashtags');
    }
    if (localStorage.getItem('name')) {
      localStorage.removeItem('name');
    }
    if (localStorage.getItem('invite_resp')) {
      localStorage.removeItem('invite_resp');
    }
    if (localStorage.getItem('event_subfolders')) {
      localStorage.removeItem('event_subfolders');
    }
    if (localStorage.getItem('web_qrImage')) {
      localStorage.removeItem('web_qrImage');
    }
    if (localStorage.getItem('web_viewer_qrImage')) {
      localStorage.removeItem('web_viewer_qrImage');
    }
    if (localStorage.getItem('coverImage')) {
      localStorage.removeItem('coverImage');
    }

    if (localStorage.getItem('openPopup')) {
      localStorage.removeItem('openPopup');
    }
    if (localStorage.getItem('formData')) {
      localStorage.removeItem('formData');
    }
    if (localStorage.getItem('isFutureEvent')) {
      localStorage.removeItem('isFutureEvent');
    }
  }


  getEventById(
    min: any,
    max: any,
    sortOrder: any,
    media_type: any,
    subFolderId: any,
    sortBy: any,
    hexOverride?: string
  ): Observable<any> {
    // hexOverride lets a caller read a specific event without first writing
    // `eventId` into localStorage. The sample-gallery peek on the empty home
    // state needs this: writing that key is what triggers the guest-session
    // handling in event-detail and the route guards.
    const event_hex = hexOverride || localStorage.getItem("eventId") || '';

    if (!event_hex || event_hex.trim() === '' || event_hex === 'null') {
      return new Observable((observer) => {
        observer.error(new Error('Event ID is missing or invalid'));
      });
    }

    const isGuestUser = localStorage.getItem('isGuestUser') === 'true';
    // console.log('isGuestUser:', isGuestUser); //__CONSOLE_LOG__

    const url = `https://5u4005m3pg.execute-api.us-west-1.amazonaws.com/pwa_fetch_media`;
    //`https://kqw2qbpk60.execute-api.us-west-1.amazonaws.com/test_pwa_fetch_media`;

    // ✅ URL + params = unique cache key (avoids event image mix-up)
    const cacheKey = `${url}?event=${event_hex}&min=${min}&max=${max}&sortOrder=${sortOrder}&media_type=${media_type}&subFolderId=${subFolderId}&sortBy=${sortBy}&isGuestUser=${isGuestUser}`;

    return new Observable((observer) => {
      this.encryptedData = localStorage.getItem('user');
      this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
      const user = JSON.parse(this.decryptedData || '{}');

      const token: any = user?.stsTokenManager?.accessToken;
      const expirationTime = user?.stsTokenManager?.expirationTime;
      const currentTime = new Date().getTime() / 1000;

      this.userCurrentTime = new Date(currentTime * 1000);
      this.userExpirationTime = new Date(expirationTime);

      const proceed = (finalToken: string) => {
        const headers = new HttpHeaders()
          .set("Content-Type", "application/x-www-form-urlencoded")
          .set("Authorization", finalToken)
          .set("sortOrder", sortOrder)
          .set("subFolderId", subFolderId.toString())
          .set("sortBy", sortBy.toString())
          .set("media_type", media_type)
          .set("hex", event_hex.toString())
          .set("min", min.toString())
          .set("max", max.toString())
          .set("isGuestUser", isGuestUser.toString());

        this.apiCache.getData<any>(cacheKey, { headers })
          .subscribe({
            next: (data) => observer.next(data),
            error: (err) => observer.error(err),
            complete: () => observer.complete()
          });
      };

      if (this.userCurrentTime < this.userExpirationTime) {
        proceed(token);
      } else {
        requestToken(this.afAuth).then((refToken) => {
          if (refToken) this.refToken = refToken;
          proceed(this.refToken);
        });
      }
    });
  }

  /**
   * Forget one album's cached photo list and photo count, so the next visit
   * fetches both. getEventById() and getTotalMediaCount() answer from a cache
   * that is not refetched until two minutes after the last fetch, which is the
   * window in which someone comes back to an album after uploading to it.
   */
  forgetAlbumPhotos(hex: string): void {
    if (!hex) {
      return;
    }
    this.apiCache.clearCache(`pwa_fetch_media?event=${hex}&`);
    this.apiCache.clearCache(`pwa_get_media_count?hex=${hex}`);
  }

  /**
   * Lightweight event summary (name, host, coverImage) — no media list, no
   * per-image S3 orientation/branding lookups. Used to paint the event-detail
   * hero/cover as soon as possible, in parallel with the heavier getEventById()
   * media fetch, instead of gating the cover image on that call's full payload.
   */
  getEventDetailLite(hex: string): Observable<any> {
    const url = 'https://tep4uy5q18.execute-api.us-west-1.amazonaws.com/default/pwa-get-event-detail-dev-getEventDetail';
    const isGuestUser = localStorage.getItem('isGuestUser') === 'true';

    return new Observable((observer) => {
      this.encryptedData = localStorage.getItem('user');
      this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
      const user = JSON.parse(this.decryptedData || '{}');

      const token: any = user?.stsTokenManager?.accessToken;
      const expirationTime = user?.stsTokenManager?.expirationTime;
      const currentTime = new Date().getTime() / 1000;

      this.userCurrentTime = new Date(currentTime * 1000);
      this.userExpirationTime = new Date(expirationTime);

      const proceed = (finalToken: string) => {
        const headers = new HttpHeaders()
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('Authorization', finalToken)
          .set('hex', hex)
          .set('isGuestUser', isGuestUser.toString());

        this.http.get(url, { headers }).subscribe({
          next: (data) => observer.next(data),
          error: (err) => observer.error(err),
          complete: () => observer.complete()
        });
      };

      if (this.userCurrentTime < this.userExpirationTime) {
        proceed(token);
      } else {
        requestToken(this.afAuth).then((refToken) => {
          if (refToken) this.refToken = refToken;
          proceed(this.refToken);
        });
      }
    });
  }

  getEventFileNames(event_id: any): Observable<any> {
    const url = 'https://edwhomxzhl.execute-api.us-west-1.amazonaws.com/dev/pwa-fetch-file-names';

    return new Observable((observer) => {
      this.encryptedData = localStorage.getItem('user');
      this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
      const user = JSON.parse(this.decryptedData || '{}');

      const token: any = user?.stsTokenManager?.accessToken;
      const expirationTime = user?.stsTokenManager?.expirationTime;
      const currentTime = new Date().getTime() / 1000;

      this.userCurrentTime = new Date(currentTime * 1000);
      this.userExpirationTime = new Date(expirationTime);

      const proceed = (finalToken: string) => {
        const headers = new HttpHeaders()
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('Authorization', finalToken)
          .set('event_id', event_id.toString());

        this.http.get(url, { headers }).subscribe({
          next: (data) => observer.next(data),
          error: (err) => observer.error(err),
          complete: () => observer.complete()
        });
      };

      if (this.userCurrentTime < this.userExpirationTime) {
        proceed(token);
      } else {
        requestToken(this.afAuth).then((refToken) => {
          if (refToken) this.refToken = refToken;
          proceed(this.refToken);
        });
      }
    });
  }


  // getEventById(
  //   min: any,
  //   max: any,
  //   sortOrder: any,
  //   media_type: any,
  //   subFolderId: any,
  //   sortBy: any
  // ): Observable<any> {
  //   let event_hex = localStorage.getItem("eventId") || '';

  //   // ✅ Return error Observable if event ID is invalid
  //   if (!event_hex || event_hex === ' ' || event_hex === 'null') {
  //     return new Observable((observer) => {
  //       observer.error(new Error('Event ID is missing or invalid'));
  //     });
  //   }

  //   const url = `https://kqw2qbpk60.execute-api.us-west-1.amazonaws.com/test_pwa_fetch_media?t=${new Date().getTime()}`;

  //   return new Observable((observer) => {
  //     this.encryptedData = localStorage.getItem('user');
  //     this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
  //     const user = JSON.parse(this.decryptedData || '{}');

  //     const token: any = user?.stsTokenManager?.accessToken;
  //     const expirationTime = user?.stsTokenManager?.expirationTime;
  //     const currentTime = new Date().getTime() / 1000;

  //     this.userCurrentTime = new Date(currentTime * 1000);
  //     this.userExpirationTime = new Date(expirationTime);

  //     const proceed = (finalToken: string) => {
  //       const headers = new HttpHeaders()
  //         .set("Content-Type", "application/x-www-form-urlencoded")
  //         .set("Authorization", finalToken)
  //         .set("sortOrder", sortOrder)
  //         .set("subFolderId", subFolderId.toString())
  //         .set("sortBy", sortBy.toString())
  //         .set("media_type", media_type)
  //         .set("hex", event_hex.toString())
  //         .set("min", min.toString())
  //         .set("max", max.toString());

  //       // ✅ Use ApiCacheService to load from cache first, then update
  //       this.apiCache.getData<any>(
  //         `${url}&hex=${event_hex}&min=${min}&max=${max}&media_type=${media_type}`,
  //         { headers }
  //       ).subscribe({
  //         next: (data) => observer.next(data),
  //         error: (err) => observer.error(err),
  //         complete: () => observer.complete()
  //       });
  //     };

  //     if (this.userCurrentTime < this.userExpirationTime) {
  //       proceed(token);
  //     } else {
  //       requestToken(this.afAuth).then((refToken) => {
  //         if (refToken) this.refToken = refToken;
  //         proceed(this.refToken);
  //       });
  //     }
  //   });
  // }


  async getEventById_1(min: any, max: any, sortOrder: any, media_type: any, subFolderId: any, sortBy: any) {
    let event_hex = localStorage.getItem("eventId") || '';
    // Check if event_hex is empty, null, or undefined
    if (!event_hex || event_hex == undefined || event_hex == ' ' || event_hex == null || event_hex == 'null') {
      // console.error('Event ID is missing or invalid'); //__CONSOLE_LOG__
      // Option 1: Return a rejected Promise with an error
      return Promise.reject(new Error('Event ID is missing or invalid'));

      // Option 2: Return an empty response or specific value
      // return { error: 'Event ID is missing or invalid' };

      // Option 3: Navigate back (uncomment if needed)
      // this.goBack();
      // return;
    }
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    const isGuestUser = localStorage.getItem('isGuestUser') === 'true' || localStorage.getItem('isDemoUser') === 'true';
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("sortOrder", sortOrder)
        .set("subFolderId", subFolderId.toString())
        .set("sortBy", sortBy.toString())
        .set("media_type", media_type)
        .set("hex", event_hex.toString())
        .set("min", min.toString())
        .set("max", max.toString())
        .set("isGuestUser", isGuestUser.toString());
      // console.log({ headers }); //__CONSOLE_LOG__

      // The live endpoint the gallery uses. The old test_pwa_fetch_media Lambda
      // crashes on every call (its CloudFront signing key is never loaded), and
      // that 500 sent the slideshow to sign-in and from there to /home.
      return this.http.get(
        `https://5u4005m3pg.execute-api.us-west-1.amazonaws.com/pwa_fetch_media?t=${new Date().getTime()}`,
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("sortOrder", sortOrder)
        .set("subFolderId", subFolderId.toString())
        .set("sortBy", sortBy.toString())
        .set("media_type", media_type)
        .set("hex", event_hex.toString())
        .set("min", min.toString())
        .set("max", max.toString())
        .set("isGuestUser", isGuestUser.toString());

      return this.http.get(
        "https://5u4005m3pg.execute-api.us-west-1.amazonaws.com/pwa_fetch_media",
        { headers }
      );
    }
  }

  gethashtags(eventId: any) {
    // console.log(eventId); //__CONSOLE_LOG__

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("event_id", eventId)
      return this.http.get(
        "https://orwp7wx2m1.execute-api.us-west-1.amazonaws.com/pwa_photowall_get_hashtags",
        { headers }
      );

    } else {
      // call utils function for token request
      const Reftoken = requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("event_id", eventId)

      return this.http.get(
        "https://orwp7wx2m1.execute-api.us-west-1.amazonaws.com/pwa_photowall_get_hashtags",
        { headers }
      );

    }
  }

  getUserContacts(event_id: any): Observable<any> {
    const url = 'https://qp3p9yqsd6.execute-api.us-west-1.amazonaws.com/pwa_get_contacts';
    const cacheKey = `${url}?event_id=${event_id}`;

    return new Observable((observer) => {
      this.encryptedData = localStorage.getItem('user');
      this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
      const user = JSON.parse(this.decryptedData || '{}');

      const token: any = user?.stsTokenManager?.accessToken;
      const expirationTime = user?.stsTokenManager?.expirationTime;
      const currentTime = new Date().getTime() / 1000;

      this.userCurrentTime = new Date(currentTime * 1000);
      this.userExpirationTime = new Date(expirationTime);

      const proceed = (finalToken: string) => {
        const headers = new HttpHeaders()
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('Authorization', finalToken)
          .set('event_id', event_id.toString());

        // ✅ Cache-first fetch
        this.apiCache.getData<any>(cacheKey, { headers }).subscribe({
          next: (data) => observer.next(data),
          error: (err) => observer.error(err),
          complete: () => observer.complete()
        });
      };

      if (this.userCurrentTime < this.userExpirationTime) {
        proceed(token);
      } else {
        requestToken(this.afAuth).then((refToken) => {
          if (refToken) this.refToken = refToken;
          proceed(this.refToken);
        });
      }
    });
  }

  // getUserContacts(event_id: any) {
  //   this.encryptedData = localStorage.getItem('user');
  //   this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
  //   const user = JSON.parse(this.decryptedData || "{}");
  //   const token: any = user?.stsTokenManager?.accessToken;
  //   // Add for AccessToken get
  //   const expirationTime = user?.stsTokenManager?.expirationTime;
  //   const currentTime = new Date().getTime() / 1000;
  //   this.userCurrentTime = new Date(currentTime * 1000);
  //   this.userExpirationTime = new Date(expirationTime);
  //   // set headers
  //   if (this.userCurrentTime < this.userExpirationTime) {
  //     const headers = new HttpHeaders()
  //       .set("Content-Type", "application/x-www-form-urlencoded")
  //       .set("Authorization", token)
  //       .set("event_id", event_id.toString());
  //     return this.http.get(
  //       "https://qp3p9yqsd6.execute-api.us-west-1.amazonaws.com/pwa_get_contacts",
  //       { headers }
  //     );

  //   } else {
  //     // call utils function for token request
  //     const Reftoken = requestToken(this.afAuth);
  //     if (Reftoken) {
  //       //   console.log(Reftoken);  
  //       this.refToken = Reftoken;
  //     }
  //     const headers = new HttpHeaders()
  //       .set("Content-Type", "application/x-www-form-urlencoded")
  //       .set("Authorization", this.refToken)
  //       .set("event_id", event_id.toString());
  //     return this.http.get(
  //       "https://qp3p9yqsd6.execute-api.us-west-1.amazonaws.com/pwa_get_contacts",
  //       { headers }
  //     );

  //   }
  // }

  getInviteInfo() {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("hex", localStorage.getItem("eventId") || "{}");
      return this.http.get(
        "https://oyelychx49.execute-api.us-west-1.amazonaws.com/pwa_get_invite_info",
        { headers }
      );

    } else {
      // call utils function for token request
      const Reftoken = requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("hex", localStorage.getItem("eventId") || "{}");

      return this.http.get(
        "https://oyelychx49.execute-api.us-west-1.amazonaws.com/pwa_get_invite_info",
        { headers }
      );

    }
  }

  // getInviteInfo() {
  //   const eventId = localStorage.getItem("eventId") || "default";
  //   const url = 'https://oyelychx49.execute-api.us-west-1.amazonaws.com/pwa_get_invite_info';
  //   const cacheKey = `${url}?eventId=${eventId}`;

  //   return new Observable((observer) => {
  //     this.encryptedData = localStorage.getItem('user');
  //     this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
  //     const user = JSON.parse(this.decryptedData || '{}');

  //     const token: any = user?.stsTokenManager?.accessToken;
  //     const expirationTime = user?.stsTokenManager?.expirationTime;
  //     const currentTime = new Date().getTime() / 1000;

  //     this.userCurrentTime = new Date(currentTime * 1000);
  //     this.userExpirationTime = new Date(expirationTime);

  //     const proceed = (finalToken: string) => {
  //       const headers = new HttpHeaders()
  //         .set('Content-Type', 'application/x-www-form-urlencoded')
  //         .set('Authorization', finalToken)
  //         .set('hex', eventId);

  //       // ✅ Cache-first fetch
  //       this.apiCache.getData<any>(cacheKey, { headers }).subscribe({
  //         next: (data) => observer.next(data),
  //         error: (err) => observer.error(err),
  //         complete: () => observer.complete()
  //       });
  //     };

  //     if (this.userCurrentTime < this.userExpirationTime) {
  //       proceed(token);
  //     } else {
  //       requestToken(this.afAuth).then((refToken) => {
  //         if (refToken) this.refToken = refToken;
  //         proceed(this.refToken);
  //       });
  //     }
  //   });
  // }


  getOpenInviteInfo() {

    const headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
    // .set("hex", localStorage.getItem("eventId") || "{}");
    return this.http.get(
      "https://g1sy6j4c0a.execute-api.us-west-1.amazonaws.com/default/pwa-fetch-rsvp-info",
      {
        params: { hex: localStorage.getItem("eventId") || "{}" },
      }
    );

  }

  getOpenEventGallery() {
    const headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
    //.set("hex", localStorage.getItem("eventId") || "{}");
    // console.log({ headers }); //__CONSOLE_LOG__ //__CONSOLE_LOG__
    return this.http.get(
      "https://78n1ciwz29.execute-api.us-west-1.amazonaws.com/dev/pwa-fetch-gallery-without-login",
      {
        params: { hex: localStorage.getItem("eventId") || "{}" }, // ✅ sent as query string
      }
    );

  }




  getInviteHistory(event_id: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("event_id", event_id.toString());
      return this.http.get(
        "https://v2nl8kvku4.execute-api.us-west-1.amazonaws.com/pwa_get_invite_history",
        { headers }
      );

    } else {
      // call utils function for token request
      const Reftoken = requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("event_id", event_id.toString());

      return this.http.get(
        "https://v2nl8kvku4.execute-api.us-west-1.amazonaws.com/pwa_get_invite_history",
        { headers }
      );

    }
  }

  async updateRsvpResponse(eventId: any, response: any, rsvp: any, guestCount: any) {

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("response", response.toString())
        .set("rsvp", rsvp.toString())
        .set("guest_count", guestCount.toString())
        .set("event_id", eventId.toString());
      // .set("invite_type",invite_type.toString());

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://bu4xu7aw7h.execute-api.us-west-1.amazonaws.com/pwa_update_rsvp",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("response", response.toString())
        .set("rsvp", rsvp.toString())
        .set("guest_count", guestCount.toString())
        .set("event_id", eventId.toString());
      // .set("invite_type",invite_type.toString());

      return this.http.post(
        "https://bu4xu7aw7h.execute-api.us-west-1.amazonaws.com/pwa_update_rsvp",
        params.toString(),
        { headers }
      );
    }
  }

  async updateAccountDetails(name: any, image: any) {

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("name", name)
        .set("image", image)
      // .set("sendEmail", sendEmail);

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://w5h8tfp5k1.execute-api.us-west-1.amazonaws.com/pwa_update_my_account_details",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("name", name)
        .set("image", image)
      //.set("sendEmail", sendEmail);

      return this.http.post(
        "https://w5h8tfp5k1.execute-api.us-west-1.amazonaws.com/pwa_update_my_account_details",
        params.toString(),
        { headers }
      );
    }
  }

  async updateMobile(phone: any) {

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("mobile", phone);

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://jomowknqe4.execute-api.us-west-1.amazonaws.com/pwa_update_mobile",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("mobile", phone);

      return this.http.post(
        "https://jomowknqe4.execute-api.us-west-1.amazonaws.com/pwa_update_mobile",
        params.toString(),
        { headers }
      );
    }
  }

  async generateAnonymousLink(eventId: string) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");

    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);

      const params = new HttpParams()
        .set("event_id", eventId.toString());

      return this.http.post(
        'https://3ggwypf0o4.execute-api.us-west-1.amazonaws.com/default/pwa-generate-anonymous-link',
        params.toString(),
        { headers }
      );
    } else {
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
      }

      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);

      const params = new HttpParams()
        .set("event_id", eventId.toString());

      return this.http.post(
        'https://3ggwypf0o4.execute-api.us-west-1.amazonaws.com/default/pwa-generate-anonymous-link',
        params.toString(),
        { headers }
      );
    }
  }

  async sendRsvpResponse(response: any, rsvp: any, invite_type: any, default_upload: any, guestCount: any, access: any) {

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("response", response)
        .set("rsvp", rsvp)
        .set("guest_count", guestCount)
        .set("default_upload", default_upload)
        .set("hex", localStorage.getItem('eventId') || "{}")
        .set("invite_type", invite_type)
        .set("access", access);

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://ezqpp33i4k.execute-api.us-west-1.amazonaws.com/pwa_respond_to_rsvp",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("response", response.toString())
        .set("rsvp", rsvp.toString())
        .set("guest_count", guestCount.toString())
        .set("default_upload", default_upload.toString())
        .set("hex", localStorage.getItem('eventId') || "{}")
        .set("invite_type", invite_type.toString())
        .set("access", access);

      return this.http.post(
        "https://ezqpp33i4k.execute-api.us-west-1.amazonaws.com/pwa_respond_to_rsvp",
        params.toString(),
        { headers }
      );
    }
  }

  async getPublicEvent(hex: any) {

    const headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("i", '464631c94957f2e1464d5af12aeee3d5')
      .set("h", hex)

    // console.log({ headers }); //__CONSOLE_LOG__

    return this.http.get(
      //"https://f55a6falwe.execute-api.us-west-1.amazonaws.com/test/pwa_fetch_media",
      "https://2ui4x4o6jk.execute-api.us-west-1.amazonaws.com/pwa_fetch_public_event",
      { headers }
    );

  }


  async togglePublicEvent(eventId: any, makePublic: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        //   .set("user_id", userId.toString())
        .set("makePublic", makePublic.toString());

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://lzyani9cn6.execute-api.us-west-1.amazonaws.com/pwa_toggle_public_event",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        // .set("user_id", userId.toString())
        .set("makePublic", makePublic.toString());
      return this.http.post(
        "https://lzyani9cn6.execute-api.us-west-1.amazonaws.com/pwa_toggle_public_event",
        params.toString(),
        { headers }
      );
    }
  }

  async toggleDefaultUpload(eventId: any, default_upload: any, isHost: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("isHost", isHost.toString())
        .set("default_upload", default_upload.toString());

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://395vjs006c.execute-api.us-west-1.amazonaws.com/pwa-update-default-upload",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("isHost", isHost.toString())
        .set("default_upload", default_upload.toString());
      return this.http.post(
        "https://395vjs006c.execute-api.us-west-1.amazonaws.com/pwa-update-default-upload",
        params.toString(),
        { headers }
      );
    }
  }

  async saveAdminSettings(formData: any) {
    // console.log(formData); //__CONSOLE_LOG__

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("image", formData.logo)
        .set("color", formData.themeColor?.hex)
        .set("text", formData.headline);

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://jm874rf1ne.execute-api.us-west-1.amazonaws.com/pwa_save_admin_settings",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("image", formData.logo)
        .set("color", formData.themeColor?.hex)
        .set("text", formData.headline);
      return this.http.post(
        "https://jm874rf1ne.execute-api.us-west-1.amazonaws.com/pwa_save_admin_settings",
        params.toString(),
        { headers }
      );
    }
  }

  async getBrandingData(eventId: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    let authToken = token;

    // Refresh token if expired
    if (this.userCurrentTime >= this.userExpirationTime) {
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
        authToken = this.refToken;
      } else {
        throw new Error("Unable to refresh token");
      }
    }
    // const headers = new HttpHeaders({
    //   "Content-Type": "application/json",
    //   "Authorization": authToken
    // });


    // return this.http.get(
    //   "https://m3a9o5xmc2.execute-api.us-west-1.amazonaws.com/default/pwa-get-branding-data?e=" + eventId,
    //   {
    //     headers
    //   }
    // );
    const options = {
      headers: new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("event_id", eventId.toString()),
    };
    return this.http.get(
      "https://in6qg1tf35.execute-api.us-west-1.amazonaws.com/default/pwa-get-branding-data",
      options
    );
  }

  async saveBrandingData(eventId: any, brandingText: any, logoName: any, position: any, prevLogo: any, brandingEnabled: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;

    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    let authToken = token;

    // Refresh token if expired
    if (this.userCurrentTime >= this.userExpirationTime) {
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
        authToken = this.refToken;
      } else {
        throw new Error("Unable to refresh token");
      }
    }

    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "Authorization": authToken
    });

    // Prepare URL-encoded body
    const body = new HttpParams()
      .set("event_id", eventId)
      .set("logo_name", logoName)
      .set("text", brandingText)
      .set("position", position)
      .set("prev_logo", prevLogo)
      .set("branding", brandingEnabled)
      .toString();


    return this.http.post(
      "https://4kcsxv6zs8.execute-api.us-west-1.amazonaws.com/dev/pwa-save-branding-data",
      body,
      { headers }
    );
  }


  async toggleEventFiles(eventId: any, file_ids: any, makePublic: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("file_ids", file_ids.toString())
        .set("makePublic", makePublic.toString());

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://0c0n9tgzjl.execute-api.us-west-1.amazonaws.com/pwa_toggle_public_files",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("file_ids", file_ids.toString())
        .set("makePublic", makePublic.toString());
      return this.http.post(
        "https://0c0n9tgzjl.execute-api.us-west-1.amazonaws.com/pwa_toggle_public_files",
        params.toString(),
        { headers }
      );
    }
  }

  async saveContact(eventId: any, userId: any, name: any, phone: any, email: any, contact_id: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("user_id", userId.toString())
        .set("name", name.toString())
        .set("phoneNumber", phone.toString())
        .set("emailAddress", email.toString())
        .set("contact_id", contact_id.toString());

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://ldoehl56t5.execute-api.us-west-1.amazonaws.com/pwa_save_event_contact",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("user_id", userId.toString())
        .set("name", name.toString())
        .set("phoneNumber", phone.toString())
        .set("emailAddress", email.toString());
      return this.http.post(
        "https://ldoehl56t5.execute-api.us-west-1.amazonaws.com/pwa_save_event_contact",
        params.toString(),
        { headers }
      );
    }
  }

  async deleteContact(eventId: any, userId: any, contactId: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("user_id", userId.toString())
        .set("contact_id", contactId.toString());

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://mxothroe7e.execute-api.us-west-1.amazonaws.com/pwa_delete_contact",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("user_id", userId.toString())
        .set("contact_id", contactId.toString());

      return this.http.post(
        "https://mxothroe7e.execute-api.us-west-1.amazonaws.com/pwa_delete_contact",
        params.toString(),
        { headers }
      );
    }
  }

  async deleteMedia(eventId: any, userId: any, fileIds: number[], selectAll: boolean = false) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      let params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("user_id", userId.toString());

      // Add select_all parameter if true, otherwise send file_ids
      if (selectAll) {
        params = params.set("select_all", "true");
        params = params.set("file_ids", ""); // Send empty string for file_ids
      } else {
        params = params.set("file_ids", fileIds.toString());
      }

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://27a4jrsd7f.execute-api.us-west-1.amazonaws.com/pwa_delete_media",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      let params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("user_id", userId.toString());

      // Add select_all parameter if true, otherwise send file_ids
      if (selectAll) {
        params = params.set("select_all", "true");
        params = params.set("file_ids", ""); // Send empty string for file_ids
      } else {
        params = params.set("file_ids", fileIds.toString());
      }

      return this.http.post(
        "https://27a4jrsd7f.execute-api.us-west-1.amazonaws.com/pwa_delete_media",
        params.toString(),
        { headers }
      );
    }
  }

  /** `whatsappInvite`: also mint the WhatsApp invite link and return it as `whatsapp_invite`. */
  async createEvent(name: any, category: any, hostedBy: any, startTime: any, endTime: any, scheduledEndTime: any, scheduledStartTime: any, eventLocation: any, default_image_id: any, message: any, cover_image_id: any, rsvp: any, coverImage: any, subfolders: any, whatsappInvite = false) {
    let cleanedMessage = (decodeURIComponent(message)).replace(/^"(.*)"$/, '$1')
    // console.log(cleanedMessage); //__CONSOLE_LOG__

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      let params = new HttpParams()
        .set("name", name.toString())
        .set("category", category.toString())
        .set("hostedBy", hostedBy.toString())
        .set("scheduledEndTime", scheduledEndTime.toString())
        .set("scheduledStartTime", scheduledStartTime.toString())
        // .set("sender_name", userName.toString())
        // .set("default_upload", default_upload.toString())
        // .set("collaborators", collaborators.toString())
        //.set("isGeoFenceEnable", isGeoFenceEnable.toString())
        .set("eventLocation", eventLocation)
        //.set("access_code_id", access_code_id.toString())
        .set("default_image_id", default_image_id)
        .set("message", cleanedMessage)
        .set("cover_image_id", cover_image_id)
        .set("rsvp", rsvp)
        .set("coverImage", coverImage)
        .set("subfolders", subfolders);
      // .set("miles", miles.toString());
      if (whatsappInvite) params = setHostTimeZone(params.set("whatsappInvite", "true"));

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://yju7rlfuod.execute-api.us-west-1.amazonaws.com/pwa_create_event",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      let params = new HttpParams()
        .set("name", name.toString())
        .set("category", category.toString())
        .set("hostedBy", hostedBy.toString())
        .set("scheduledEndTime", scheduledEndTime.toString())
        .set("scheduledStartTime", scheduledStartTime.toString())
        //.set("sender_name", userName.toString())
        // .set("default_upload", default_upload.toString())
        // .set("collaborators", collaborators.toString())
        //.set("isGeoFenceEnable", isGeoFenceEnable.toString())
        .set("eventLocation", eventLocation)
        //.set("access_code_id", access_code_id.toString())
        .set("default_image_id", default_image_id)
        .set("message", cleanedMessage)
        .set("cover_image_id", cover_image_id)
        .set("rsvp", rsvp)
        .set("coverImage", coverImage)
        .set("subfolders", subfolders);
      // .set("miles", miles.toString());
      if (whatsappInvite) params = setHostTimeZone(params.set("whatsappInvite", "true"));
      return this.http.post(
        "https://yju7rlfuod.execute-api.us-west-1.amazonaws.com/pwa_create_event",
        params.toString(),
        { headers }
      );
    }
  }

  async stopEvent(event_id: any, isHost: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("event_id", event_id.toString())
        .set("isHost", isHost)

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://99ecxxh462.execute-api.us-west-1.amazonaws.com/pwa-stop-event-host",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", event_id.toString())
        .set("isHost", isHost)
      return this.http.post(
        "https://99ecxxh462.execute-api.us-west-1.amazonaws.com/pwa-stop-event-host",
        params.toString(),
        { headers }
      );
    }
  }

  /**
   * Update only the scheduled end time of an event (used by the "Extend Event
   * Duration" dialog on the Live tile). Unlike updateScheduledEvent, this touches
   * nothing but the end time, so it can't blank out the event's other fields.
   *
   * @param event_id          The event id.
   * @param scheduledEndTime  New end time as a Unix timestamp in seconds.
   */
  async updateScheduledEndTime(event_id: any, scheduledEndTime: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      const params = new HttpParams()
        .set("event_id", event_id.toString())
        .set("scheduledEndTime", scheduledEndTime.toString());
      return this.http.post(
        "https://cub9jar2g8.execute-api.us-west-1.amazonaws.com/default/pwa-update-scheduled-end-time",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", event_id.toString())
        .set("scheduledEndTime", scheduledEndTime.toString());
      return this.http.post(
        "https://cub9jar2g8.execute-api.us-west-1.amazonaws.com/default/pwa-update-scheduled-end-time",
        params.toString(),
        { headers }
      );
    }
  }

  async inviteUsers(event_id: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      const params = new HttpParams()
        .set("event_id", event_id.toString());

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://ztky4wt7q7.execute-api.us-west-1.amazonaws.com/pwa_invite_users",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", event_id.toString());
      return this.http.post(
        "https://ztky4wt7q7.execute-api.us-west-1.amazonaws.com/pwa_invite_users",
        params.toString(),
        { headers }
      );
    }
  }

  async getAllCategories(): Promise<Observable<any>> {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);

      return this.http.get(
        "https://tasowj3kh2.execute-api.us-west-1.amazonaws.com/pwa_get_categories",
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);

      return this.http.get(
        "https://tasowj3kh2.execute-api.us-west-1.amazonaws.com/pwa_get_categories",
        { headers }
      );
    }
  }

  async addComment(comment: any, file_id: any, user_name: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      const params = new HttpParams()
        .set("user_name", user_name.toString())
        .set("comment", comment.toString())
        .set("file_id", file_id.toString());

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://q1nfahkws2.execute-api.us-west-1.amazonaws.com/pwa_add_photo_comment",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("user_name", user_name.toString())
        .set("comment", comment.toString())
        .set("file_id", file_id.toString());
      return this.http.post(
        "https://q1nfahkws2.execute-api.us-west-1.amazonaws.com/pwa_add_photo_comment",
        params.toString(),
        { headers }
      );
    }
  }

  async sendNotification(event_id: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      const params = new HttpParams()
        .set("event_id", event_id.toString());

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://8y660byc34.execute-api.us-west-1.amazonaws.com/pwa_send_notification",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", event_id.toString());
      return this.http.post(
        "https://8y660byc34.execute-api.us-west-1.amazonaws.com/pwa_send_notification",
        params.toString(),
        { headers }
      );
    }
  }


  async likePhoto(liked: any, file_id: any, user_name: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      const params = new HttpParams()
        .set("user_name", user_name.toString())
        .set("liked", liked.toString())
        .set("file_id", file_id.toString());

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://b03v24xdl5.execute-api.us-west-1.amazonaws.com/pwa_like_file",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("user_name", user_name.toString())
        .set("liked", liked.toString())
        .set("file_id", file_id.toString());
      return this.http.post(
        "https://b03v24xdl5.execute-api.us-west-1.amazonaws.com/pwa_like_file",
        params.toString(),
        { headers }
      );
    }
  }

  async createVideo(eventId: any, userId: any, fileIds: number[], isGuestUser?: boolean) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("user_id", userId.toString())
        .set("file_ids", fileIds.toString())
        .set("isGuestUser", isGuestUser ? 'true' : 'false');

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://w9c2b839oa.execute-api.us-west-1.amazonaws.com/create_video",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("user_id", userId.toString())
        .set("file_ids", fileIds.toString());
      return this.http.post(
        "https://w9c2b839oa.execute-api.us-west-1.amazonaws.com/create_video",
        params.toString(),
        { headers }
      );
    }
  }


  pwaFetchData(hex: any) {
    const headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("hex", hex)

    return this.http.get(
      "https://7ndc927c6c.execute-api.us-west-1.amazonaws.com/pwa_fetch_hex_status",
      { headers }
    );
  }

  /**
   * Log file access to file_access table for tracking views, impressions, and downloads per user
   * @param fileIds Array of file IDs to log access for
   * @param type Type of access: 'view' | 'impression' | 'download'
   * @param source Source of the access, default 'pwa'
   * @returns Promise with the API response
   */
  async logFileAccess(
    fileIds: string[],
    type: string,
    source: string = 'pwa'
  ) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);

      const params = new HttpParams()
        .set("file_ids", fileIds.toString())
        .set("type", type)
        .set("source", source);

      return this.http.post(
        "https://emu354m7kc.execute-api.us-west-1.amazonaws.com/default/add-file-access-log",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);

      const params = new HttpParams()
        .set("file_ids", fileIds.toString())
        .set("type", type)
        .set("source", source);

      return this.http.post(
        "https://emu354m7kc.execute-api.us-west-1.amazonaws.com/default/add-file-access-log",
        params.toString(),
        { headers }
      );
    }
  }

  async generateWhatsappToken(eventID: any, tokenType: 'SINGLE_USE' | 'INVITE' = 'SINGLE_USE', validityMinutes?: number) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    let buildParams = (base: HttpParams) => {
      base = setHostTimeZone(base.set("tokenType", tokenType));
      if (tokenType === 'INVITE' && validityMinutes) {
        base = base.set("validityMinutes", validityMinutes.toString());
      }
      return base;
    };

    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);

      const params = buildParams(new HttpParams()
        .set("eventId", eventID.toString())
        .set("source", 'PWA'));

      return this.http.post(
        "https://jc4a6g12yj.execute-api.us-west-1.amazonaws.com/default/pwa-generate-whatsapp-token",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);

      const params = buildParams(new HttpParams()
        .set("eventId", eventID.toString()));

      return this.http.post(
        "https://jc4a6g12yj.execute-api.us-west-1.amazonaws.com/default/pwa-generate-whatsapp-token",
        params.toString(),
        { headers }
      );
    }
  }

  // Event Branding Settings APIs
  async getEventBranding(eventId: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", token)
        .set("eventId", eventId);

      return this.http.get(
        `https://61jque25mb.execute-api.us-west-1.amazonaws.com/dev/pwa-get-event-branding`,
        { headers }
      );
    } else {
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", this.refToken)
        .set("eventId", eventId);

      return this.http.get(
        `https://61jque25mb.execute-api.us-west-1.amazonaws.com/dev/pwa-get-event-branding`,
        { headers }
      );
    }
  }

  async updateDefaultTab(event_id: string, default_tab: string): Promise<Observable<any>> {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", token);

      return this.http.post(
        "https://qk1zjhc4h9.execute-api.us-west-1.amazonaws.com/default/pwa-save-event-settings",
        { event_id, default_tab },
        { headers }
      );
    } else {
      const Reftoken = await requestToken(this.afAuth);
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", Reftoken || "");

      return this.http.post(
        "https://qk1zjhc4h9.execute-api.us-west-1.amazonaws.com/default/pwa-save-event-settings",
        { event_id, default_tab },
        { headers }
      );
    }
  }

  async updateBulkDownloadPermission(event_id: string, bulk_download: boolean): Promise<Observable<any>> {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", token);

      return this.http.post(
        "https://qk1zjhc4h9.execute-api.us-west-1.amazonaws.com/default/pwa-save-event-settings",
        { event_id, bulk_download },
        { headers }
      );
    } else {
      const Reftoken = await requestToken(this.afAuth);
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", Reftoken || "");

      return this.http.post(
        "https://qk1zjhc4h9.execute-api.us-west-1.amazonaws.com/default/pwa-save-event-settings",
        { event_id, bulk_download },
        { headers }
      );
    }
  }

  async updateDefaultSortOrder(event_id: string, default_sort_order: string): Promise<Observable<any>> {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", token);

      return this.http.post(
        "https://qk1zjhc4h9.execute-api.us-west-1.amazonaws.com/default/pwa-save-event-settings",
        { event_id, default_sort_order },
        { headers }
      );
    } else {
      const Reftoken = await requestToken(this.afAuth);
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", Reftoken || "");

      return this.http.post(
        "https://qk1zjhc4h9.execute-api.us-west-1.amazonaws.com/default/pwa-save-event-settings",
        { event_id, default_sort_order },
        { headers }
      );
    }
  }

  async saveEventBranding(brandingData: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", token);

      return this.http.post(
        "https://7x0wlb8fae.execute-api.us-west-1.amazonaws.com/dev/pwa-save-event-branding",
        brandingData,
        { headers }
      );
    } else {
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", this.refToken);

      return this.http.post(
        "https://7x0wlb8fae.execute-api.us-west-1.amazonaws.com/dev/pwa-save-event-branding",
        brandingData,
        { headers }
      );
    }
  }

  async updateEventBrandingStatus(eventId: any, isActive: boolean) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    const payload = {
      event_id: eventId,
      event_branding: isActive
    };

    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", token);

      return this.http.post(
        "https://xggu4z1pb8.execute-api.us-west-1.amazonaws.com/default/pwa-toggle-event-branding",
        payload,
        { headers }
      );
    } else {
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", this.refToken);

      return this.http.post(
        "https://xggu4z1pb8.execute-api.us-west-1.amazonaws.com/default/pwa-toggle-event-branding",
        payload,
        { headers }
      );
    }
  }

  // User Branding Methods
  async getUserBranding() {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", token);

      return this.http.get(
        `https://k2ng5lqhx6.execute-api.us-west-1.amazonaws.com/dev/pwa-get-user-branding`,
        { headers }
      );
    } else {
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", this.refToken);

      return this.http.get(
        `https://k2ng5lqhx6.execute-api.us-west-1.amazonaws.com/dev/pwa-get-user-branding`,
        { headers }
      );
    }
  }

  async saveUserBranding(brandingData: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", token);

      return this.http.post(
        "https://7xpxf545t4.execute-api.us-west-1.amazonaws.com/dev/pwa-save-user-branding",
        brandingData,
        { headers }
      );
    } else {
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", this.refToken);

      return this.http.post(
        "https://7xpxf545t4.execute-api.us-west-1.amazonaws.com/dev/pwa-save-user-branding",
        brandingData,
        { headers }
      );
    }
  }

  async downloadAllImagesAsZip(eventId: string, quality: 'compressed' | 'originals' = 'compressed', mediaType: 'images' | 'all' = 'images'): Promise<any> {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    const body = {
      event_id: eventId,
      quality: quality,
      media_type: mediaType
    };

    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", token);

      return this.http.post(
        "https://ykfi6t788f.execute-api.us-west-1.amazonaws.com/default/pwa-download-bulk-media",
        body,
        { headers }
      ).toPromise();
    } else {
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", this.refToken);

      return this.http.post(
        "https://ykfi6t788f.execute-api.us-west-1.amazonaws.com/default/pwa-download-bulk-media",
        body,
        { headers }
      ).toPromise();
    }
  }

  // jobId: the job this device is polling. eventId (with jobId null): this
  // user's newest finished zip for the event, kept 7 days (the "ready" sheet).
  async checkDownloadStatus(jobId: string | null, eventId?: any): Promise<any> {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager?.accessToken;
    const expirationTime = user?.stsTokenManager?.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    const body = jobId ? { download_log_id: jobId } : { event_id: eventId };

    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", token);

      return this.http.post(
        "https://s2pbollb30.execute-api.us-west-1.amazonaws.com/default/pwa-check-download-status",
        body,
        { headers }
      ).toPromise();
    } else {
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", this.refToken);

      return this.http.post(
        "https://s2pbollb30.execute-api.us-west-1.amazonaws.com/default/pwa-check-download-status",
        body,
        { headers }
      ).toPromise();
    }
  }

}
